import { Button, Form, Tabs, Tag, Input, Select } from 'antd';

import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import DataBreachService from '../../../../services/DataBreach.service';
import ModalFail from '../../../../components/Shared/modal/fail';
import ModalSuccess from '../../../../components/Shared/modal/success';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import ModalReject from '../form/components/ModalReject';
import { DownOutlined } from '@ant-design/icons';
import { useEffect, useState, useRef } from 'react';
import IconBack from '../../../../assets/Images/icons/icon-back';
import UserService from '../../../../services/UserService';
import { ROUTER } from '../../../../constants/router';
import { useBlocker } from '../../../../util/usePrompt';
import useNotify from '../../../../context/Notification/useNotify';
import Collapse from '../form/Collapse';
import useQuery from '../../../../util/useQuery';
import Tab1 from './components/Tab1Component';
import Tab2 from './components/Tab2Component';
import Tab3 from './components/Tab3Component';
import Tab4 from './components/Tab4Component';
import Tab5 from './components/Tab5Component';
import parse from 'html-react-parser';
import moment from 'moment';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DownloadOutlined } from '@ant-design/icons';
import HtmlToDoc from './components/HtmlToDoc';
import useDownlaod from '../hook/useDownlaod';

const DataBreachLogForm = () => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const { t, i18n } = useTranslation('data-breach');
    const lang = i18n?.language;
    const [form] = Form.useForm();
    const [tab2Form] = Form.useForm();
    const [tab4Form] = Form.useForm();
    const [reasonForm] = Form.useForm();
    const [formOwner] = Form.useForm();
    const [userOptions, setUserOptions] = useState([]);

    let { id } = useParams();
    const notify = useNotify();
    const navigate = useNavigate();
    const params = useQuery();

    const [loadinSave, setLoadinSave] = useState(false);
    const [loadingOwner, setLoadingOwner] = useState(false);

    const [openModalStatus, setOpenModalStatus] = useState(undefined);
    const [editFlag, setEditFlag] = useState(false);
    const [isChangeLocation, setIsChangeLocation] = useState();
    const [change, setChange] = useState(false);
    const [nextLocation, setNextLocation] = useState();
    const skipBlockerRef = useRef(false);
    const [selectedReviewer, setSelectedReviewer] = useState([]);

    const [dataBreachLogDetail, setDataBreachLogDetail] = useState([]);
    const [isRename, setIsRename] = useState(false);
    const [changeName, setChangeName] = useState(false);
    const [changeOwner, setChangeOwner] = useState(false);
    const [isOwner, setIsOwner] = useState(false);

    const [userPermission, setUserPermission] = useState([]);
    const [jsonDetail, setJsonDetail] = useState([]);

    const [openConfirmStart, setOpenConfirmStart] = useState(false);
    const [openConfirmEnd, setOpenConfirmEnd] = useState(false);
    const [openConfirmComplete, setOpenConfirmComplete] = useState(false);
    const [triggerDetails, setTriggerDetails] = useState(false);
    const { TabPane } = Tabs;
    const [consequence, setConsequence] = useState([]);
    const [consequenceConvert, setConsequenceConvert] = useState([]);
    const [validateTab2, setValidateTab2] = useState(true);
    const [validateTab3, setValidateTab3] = useState(true);
    const [validateTab4, setValidateTab4] = useState(true);
    const [viewMode, setViewMode] = useState(true);
    const [viewMode4, setViewMode4] = useState(true);
    const [actionData, setActionData] = useState([]);
    const [tab1Result, setTab1Result] = useState([]);
    const [questionSequence, setQuestionSequence] = useState(0);
    const [isManual, setIsManual] = useState(false);

    const [currentPage, setCurrentPage] = useState({
        tDataBreachId: id,
        sd: 'action_plan_name',
        s: 'ASC',
    });

    const suffix = (
        <>
            <span>
                {selectedReviewer.length} / {3}
            </span>
            <DownOutlined />
        </>
    );
    const getUser = async () => {
        try {
            const { data } = await DataBreachService.getUserList();
            if (data?.resultData) {
                setUserOptions(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getActionPlanList = (pageValue, status) => {
        const payload = {
            sd: pageValue.sortBy || 'action_plan_name',
            s: pageValue.sortDirection || 'asc',
            tDataBreachId: id,
        };
        DataBreachService.getActionPlanList(payload).then((res) => {
            setActionData(res?.data?.resultData || []);
            const result = isAllStatusToDoOrInProgress(res?.data?.resultData);
            if (status === 'Reject') {
                setValidateTab3(false);
            } else {
                if (result) {
                    setValidateTab3(false);
                } else {
                    setValidateTab3(true);
                }
            }
        });
    };

    // trigger download
    const [isHaveSelf, setIsHaveSelf] = useState(false);
    const [isHaveConsequence, setIsHaveConsequence] = useState(false);

    const getConsequenceDetail = async (detailId, status) => {
        try {
            const { data } = await DataBreachService.getConsequenceDetail(
                detailId
            );
            if (data?.resultData) {
                setValidateTab2(false);
                setIsHaveConsequence(true);
                const parsedAnswer = JSON.parse(data.resultData.answer);
                if (parsedAnswer.question102) {
                    const dayjsDate = dayjs(parsedAnswer.question102).tz(
                        'Asia/Bangkok'
                    );
                    parsedAnswer.question102 = moment(dayjsDate.toISOString()); // Convert to moment
                }
                tab2Form.setFieldsValue(parsedAnswer);
                setConsequenceConvert(parsedAnswer);
                setConsequence(data?.resultData);
            } else {
                if (status === 'Reject') {
                    setValidateTab2(false);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getInforming = async (detailId, status) => {
        try {
            const { data } = await DataBreachService.getInformingDetail(
                detailId
            );

            if (data?.resultData?.length > 0) {
                setValidateTab4(false);
                setIsHaveSelf(true);
            } else {
                if (status === 'Reject') {
                    setValidateTab4(false);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getDataBreachLogDetail = async (value) => {
        try {
            const { data } = await DataBreachService.getDataBreachLogDetail(
                value
            );
            if (data?.resultData) {
                await setDataBreachLogDetail(data?.resultData);
                const parsedData = JSON.parse(data?.resultData?.jsonData);
                setJsonDetail(parsedData);
                await setField(data?.resultData);
                await getUserPermission(data?.resultData?.tdataBreachId);

                await getConsequenceDetail(
                    data?.resultData?.tdataBreachId,
                    data?.resultData?.statusEn
                );
                await getActionPlanList(
                    currentPage,
                    data?.resultData?.statusEn
                );
                await getSelfAssessment();
                await getInforming(
                    data?.resultData?.tdataBreachId,
                    data?.resultData?.statusEn
                );
                await getUser();
            }
        } catch (error) {
            console.log(error);
        }
    };
    const getUserPermission = async (value) => {
        try {
            const { data } = await DataBreachService.getUserPermission(value);
            if (data?.resultData) {
                setUserPermission(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const setField = async (resultData) => {
        if (!resultData) return;
        const investigatorArray = resultData.investigatorId
            .split(', ')
            .map((id) => id.trim());
        setSelectedReviewer(investigatorArray);
        form.setFieldsValue({
            name: resultData.dataBreachEventName,
        });
        formOwner.setFieldsValue({
            owner: investigatorArray,
        });
        const parsedData = JSON.parse(resultData.jsonData);
        //trigger git
        if (parsedData?.groupQuestion[0]) {
            parsedData?.groupQuestion[0].length === 0 && setIsManual(true);
        }
    };

    useBlocker((nextLocation) => {
        if (!skipBlockerRef.current) {
            onChangePage(nextLocation);
        }
    }, change === true);
    const onChangePage = (nextLocation) => {
        if (skipBlockerRef.current) return;
        setEditFlag(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => { };

    const handelOkLocation = async () => {
        await setEditFlag(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const keepEditing = async () => {
        setEditFlag(false);
    };

    const rejectForm = async () => {
        setOpenConfirmEnd(true);
    };

    const startForm = async () => {
        setOpenConfirmStart(true);
    };

    const checkValidate = async () => {
        let validateTab = [];
        //validate consequence
        if (!isHaveConsequence) {
            setValidateTab2(true);
            validateTab.push(1);
        }
        //validate action plan
        const result = isAllStatusToDoOrInProgress(actionData);
        if (!result) {
            setValidateTab3(true);
            validateTab.push(2);
        }
        //validate informing
        if (!isHaveSelf) {
            setValidateTab4(true);
            validateTab.push(3);
        }
        return validateTab;
    };

    const completeForm = async () => {
        const arr = await checkValidate();
        setOpenConfirmComplete(false);
        if (arr.length === 0) {
            await changeAction('499b052674e94f1185c4f317db9cef52');
        } else {
            if (arr.length > 0) {
                if (arr[0] === 1) {
                    setViewMode(false);
                    tab2Form.validateFields();
                } else if (arr[0] === 3) {
                    setViewMode4(false);
                    tab4Form.validateFields();
                }
                navigate(`${ROUTER.DATA_BREACH.LOG_FORM}/${id}?tab=${arr[0]}`);
            }
        }
    };

    const isAllStatusToDoOrInProgress = (data) =>
        data.length > 0 && data.every((item) => item.statusEn === 'Completed');

    const changeAction = async (action) => {
        // setOpenConfirmStart(true)
        const payload = {
            txnDataBreachId: id,
            action: action,
            reason: '',
        };
        setOpenConfirmStart(false);
        setOpenConfirmEnd(false);

        DataBreachService.startDataBreach(payload)
            .then((res) => {
                if (res.data.resultMsg === 'SUCCESS') {
                    setOpenModalStatus(true);
                    getDataBreachLogDetail(id);
                } else {
                    setOpenModalStatus(false);
                }
                setLoadinSave(false);
                // setChangeEdit(false);
            })
            .catch((err) => {
                notify({
                    type: 'error',
                    title: t('Fail'),
                    description: t('FailedtoSubmitData'),
                    closeable: true,
                    timeOut: 120000,
                });
                setLoadinSave(false);
            });
    };

    const cancelReject = async () => {
        setOpenConfirmEnd(false);
        reasonForm.resetFields();
    };

    const role = UserService.role()?.toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    useEffect(() => {
        if (!admin) {
            navigate(`/not-found`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [admin]);

    useEffect(() => {
        if (!viewMode) {
            getDataBreachLogDetail(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewMode]);

    const question = [
        {
            sequence: 0,
            name: 'q0',
            q_en: '1. Have you determined whether a Personal Data Breach (PDB) has occurred?',
            q_th: '1. คุณได้ตรวจสอบแล้วว่า มีการละเมิดข้อมูลส่วนบุคคลเกิดขึ้นหรือไม่ ?',
            text_en:
                '<p className="mb-0 font-normal text-sm text-[#171717]">A personal data breach (PDB) can be broadly defined as a security incident that has affected the confidentiality, integrity or availability of personal data.</p>',
            text_th:
                '<p className="mb-0 font-normal text-sm text-[#171717]">การละเมิดข้อมูลส่วนบุคคล สามารถนิยามได้กว้างๆ ได้ว่าเป็นเหตุการณ์ด้านความมั่นคงปลอดภัย ที่ส่งผลกระทบต่อการธำรงไว้ซึ่งความลับของข้อมูลส่วนบุคคล (Confidentiality) ความถูกต้องครบถ้วน (integrity) และสภาพพร้อมใช้งาน (availability) ของข้อมูลส่วนบุคคล</p>',
            options: [
                {
                    key: 1,
                    name_en: 'Yes',
                    name_th: 'ใช่',
                },
                {
                    key: 2,
                    name_en: 'No',
                    name_th: 'ไม่',
                },
                {
                    key: 3,
                    name_en:
                        "I don't know if a personal data breach has occurred",
                    name_th:
                        'ฉันไม่ทราบว่ามีการละเมิดข้อมูลส่วนบุคคลเกิดขึ้นหรือไม่',
                },
            ],
        },
        {
            sequence: 1,
            name: 'q1',
            q_en: '2. Making your own assessment, does the breach involve the personal data of living individuals? ',
            q_th: '2. จากการประเมินของคุณแล้ว การละเมิดนี้เกี่ยวข้องกับข้อมูลส่วนบุคคลของบุคคลที่มีชีวิตหรือไม่ ?',
            text_en:
                '<p className="mb-2 font-normal text-sm text-[#171717]">Personal data is information that relates to an identified or identifiable individual.</p>',
            text_th:
                '<p className="mb-2 font-normal text-sm text-[#171717]">ข้อมูลส่วนบุคคลคือข้อมูลที่เกี่ยวข้องกับบุคคลที่ระบุตัวตนหรือสามารถระบุตัวตนได้</p>',
            options: [
                {
                    key: 1,
                    name_en: 'Yes',
                    name_th: 'ใช่',
                },
                {
                    key: 2,
                    name_en: 'No',
                    name_th: 'ไม่',
                },
            ],
        },
        {
            sequence: 2,
            name: 'q2',
            q_en: '3. Following your own assessment, is there likely to be a high risk to individuals’ rights and freedoms?',
            q_th: '3. จากการประเมินของคุณแล้ว มีแนวโน้มที่จะมีความเสี่ยงสูงต่อสิทธิและเสรีภาพของบุคคลหรือไม่ ?',
            text_en:
                '<p className="font-normal text-sm text-[#171717]">You will need to assess both the severity of the potential or actual impact on individuals as a result of a breach and the likelihood of this occurring. If the impact of the breach is more severe, the risk is higher; if the likelihood of the consequences is greater, then again the risk is higher.</p><p>To help you assess the severity of a breach you can see examples taken from various breaches reported to the PDPC. These also include helpful advice about next steps to take or things to think about. This link will open in a new browser tab. <a className="text-[#1890FF]" href="https://www.dga.or.th/wp-content/uploads/2024/04/25651215_%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B9%81%E0%B8%99%E0%B8%A7%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%A1%E0%B8%B4%E0%B8%99%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B9%80%E0%B8%AA%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%87%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B9%81.pdf target="_blank"">Personal data breach examples</a></p>',
            text_th:
                '<p className="font-normal text-sm text-[#171717]">คุณจะต้องประเมินทั้งความรุนแรงของผลกระทบที่อาจเกิดขึ้นหรือเกิดขึ้นจริงต่อบุคคลอันเป็นผลจากการละเมิดและความเป็นไปได้ที่สิ่งนี้จะเกิดขึ้น หากผลกระทบของการละเมิดรุนแรงมากขึ้น ความเสี่ยงก็จะสูงขึ้น แต่หากความเป็นไปได้ของผลที่ตามมามีมากขึ้น ความเสี่ยงก็จะสูงขึ้นเช่นกัน</p><p>เพื่อช่วยคุณประเมินความร้ายแรงของการละเมิด คุณสามารถดูตัวอย่างจากการละเมิดต่างๆ ที่รายงานไปยัง สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) ตัวอย่างเหล่านี้ยังรวมถึงคำแนะนำที่เป็นประโยชน์เกี่ยวกับขั้นตอนต่อไปที่ต้องดำเนินการหรือสิ่งที่ต้องคำนึงถึง ลิงก์นี้จะเปิดในแท็บเบราว์เซอร์ใหม่  <a className="text-[#1890FF]" href="https://www.dga.or.th/wp-content/uploads/2024/04/25651215_%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B9%81%E0%B8%99%E0%B8%A7%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B9%80%E0%B8%A1%E0%B8%B4%E0%B8%99%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B9%80%E0%B8%AA%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%87%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B9%81.pdf" target="_blank"><u>ตัวอย่างการละเมิดข้อมูลส่วนบุคคล</u></a></p>',
            options: [
                {
                    key: 1,
                    name_en: 'Yes',
                    name_th: 'ใช่',
                },
                {
                    key: 2,
                    name_en: 'No',
                    name_th: 'ไม่',
                },
            ],
        },
        {
            sequence: 3,
            name: 'q3',
            q_en: '4. How likely is it that the breach will result in a risk to individuals?',
            q_th: '4. มีโอกาสมากเพียงใดที่การละเมิดจะส่งผลให้เกิดความเสี่ยงต่อบุคคล ?',
            text_en:
                '<p className="mb-0 font-normal text-sm text-[#171717]">Again, you will need to assess both the severity of the potential or actual impact on individuals as a result of a breach and the likelihood of this occurring. If the impact of the breach is more severe, the risk is higher; if the likelihood of the consequences is greater, then again the risk is higher.</p>',
            text_th:
                '<p className="mb-0 font-normal text-sm text-[#171717]">คุณจะต้องประเมินทั้งความรุนแรงของผลกระทบที่อาจเกิดขึ้นหรือเกิดขึ้นจริงต่อบุคคลอันเป็นผลจากการละเมิดและความเป็นไปได้ที่สิ่งนี้จะเกิดขึ้น หากผลกระทบของการละเมิดรุนแรงมากขึ้น ความเสี่ยงก็จะสูงขึ้น หากความเป็นไปได้ของผลที่ตามมาสูงขึ้น ความเสี่ยงก็จะสูงขึ้นเช่นกัน</p>',
            options: [
                {
                    key: 1,
                    name_en: "I'm not sure",
                    name_th: 'ฉันไม่แน่ใจ',
                },
                {
                    key: 2,
                    name_en: 'Unlikely',
                    name_th: 'ไม่น่าจะเป็นไปได้',
                },
                {
                    key: 3,
                    name_en: 'Likely',
                    name_th: 'มีแนวโน้ม',
                },
            ],
        },
        {
            sequence: 4,
            name: 'q4',
            q_en: '5. Do you consider the data to be contained and the risk to data subjects mitigated?',
            q_th: '5. คุณคิดว่าข้อมูลได้รับการเก็บรักษาไว้และความเสี่ยงต่อเจ้าของข้อมูลได้รับการบรรเทาลงหรือไม่ ?',
            text_en:
                '<p className="mb-0 font-normal text-sm text-[#171717]">To assist you assess the risk to the data subject you should consider if the personal data concerned is contained, for example:</p><ul className="mb-0 font-normal text-sm text-[#171717]"><li>Has any lost data been located?</li><li>Was the data sent to a trusted recipient?</li><li>Have you asked the recipient to return the data or securely dispose of it?</li><li>Have steps been taken to confirm the recipient has returned or securely disposed of the data?</li><li>Did the recipient proactively contact you to advise you of the breach?</li><li>Was the data encrypted or password protected or now beyond use?</li></ul><p className="className="mb-0 font-normal text-sm text-[#171717]">Taking into account the above points (which is not exhaustive), do you consider the data to be contained and the risk to data subjects mitigated?</p>',
            text_th:
                '<p className="mb-0 font-normal text-sm text-[#171717]">เพื่อช่วยคุณประเมินความเสี่ยงต่อเจ้าของข้อมูล คุณควรพิจารณาว่าข้อมูลส่วนบุคคลที่เกี่ยวข้องมีอยู่หรือไม่ ตัวอย่างเช่น:</p><ul className="mb-0 font-normal text-sm text-[#171717]"><li>มีการค้นพบข้อมูลที่สูญหายหรือไม่?</li><li>ข้อมูลถูกส่งไปยังผู้รับที่เชื่อถือได้หรือไม่?</li><li>คุณได้ขอให้ผู้รับส่งคืนข้อมูลหรือกำจัดข้อมูลอย่างปลอดภัยหรือไม่?</li><li>ได้มีการดำเนินการตามขั้นตอนเพื่อยืนยันว่าผู้รับได้ส่งคืนหรือกำจัดข้อมูลอย่างปลอดภัยแล้วหรือไม่</li><li>ผู้รับได้ติดต่อคุณโดยตรงเพื่อแจ้งให้คุณทราบถึงการละเมิดหรือไม่</li><li>ข้อมูลถูกเข้ารหัสหรือมีการป้องกันด้วยรหัสผ่านหรือไม่สามารถใช้งานได้แล้ว?</li></ul><p className="className="mb-0 font-normal text-sm text-[#171717]">เมื่อพิจารณาถึงประเด็นข้างต้น (ซึ่งไม่ครอบคลุมทั้งหมด) คุณพิจารณาว่าข้อมูลมีอยู่ในนั้นและความเสี่ยงต่อเจ้าของข้อมูลได้รับการบรรเทาลงหรือไม่</p>',
            options: [
                {
                    key: 1,
                    name_en: 'Yes',
                    name_th: 'ใช่',
                },
                {
                    key: 2,
                    name_en: 'No',
                    name_th: 'ไม่',
                },
            ],
        },
        {
            sequence: 5,
            name: 'q5',
            q_en: 'No, a personal data breach has not occurred',
            q_th: 'การละเมิดข้อมูลส่วนบุคคลไม่ได้เกิดขึ้น',
            text_en:
                '<p className="mb-0 font-normal text-sm text-[#171717]">A personal data breach has not occurred. There is no requirement to notify the PDPC.</p>',
            text_th:
                '<p className="mb-0 font-normal text-sm text-[#171717]">ยังไม่มีการละเมิดข้อมูลส่วนบุคคลเกิดขึ้น ไม่จำเป็นต้องแจ้งให้ สคส. ทราบ</p>',
        },
        {
            sequence: 6,
            name: 'q6',
            q_en: "I don't know if a personal data breach has occurred",
            q_th: 'ฉันไม่ทราบว่ามีการละเมิดข้อมูลส่วนบุคคลเกิดขึ้นหรือไม่',
            text_en:
                '<p className="font-normal text-sm text-[#171717]">The Personal Data Protection Commission has announced the <a className="text-[#1890FF] underline" href="https://www.pdpc.or.th/2971/" target="_blank">Personal Data Controller’s Security Measures B.E. 2565</a>, which states that personal data controllers are required to have appropriate security measures in place to prevent the loss, access, use, alteration, modification or disclosure of personal data without authorization or unauthorized means that you should review all measures in place and determine whether a personal data breach has occurred.</p><p className="font-normal text-sm text-[#171717]">Please ring helpline to discuss the incident in more detail and offer advice on how to manage any breach and mitigate its effect.</p><p className="font-normal text-sm text-[#171717]">The helpline, on 02 111 8800 during business hours, 8:30 a.m. - 4:30 p.m., except holidays and public holidays. If the helpline is closed, you may prefer to report the incident without delay. You can do this online by emailing saraban@pdpc.or.th You are required to report breaches within 72 hours of becoming aware of them.</p>',
            text_th:
                '<p className="font-normal text-sm text-[#171717]">คณะกรรมการการคุ้มครองข้อมูลส่วนบุคคลได้ประกาศ เรื่อง <a className="text-[#1890FF] underline" href="https://www.pdpc.or.th/2971/" target="_blank">มาตรการรักษาความมั่นคงปลอดภัยของผู้ควบคุมข้อมูลส่วนบุคคล พ.ศ. 2565</a> ระบุว่า ให้ผู้ควบคุมข้อมูลส่วนบุคคลมีหน้าที่จัดให้มีมาตรการรักษา ความมั่นคงปลอดภัยที่เหมาะสม เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข หรือเปิดเผย ข้อมูลส่วนบุคคลโดยปราศจากอำนาจหรือโดยมิชอบ ซึ่งหมายความว่าคุณควรตรวจสอบมาตรการทั้งหมดที่มีอยู่และตัดสินใจว่ามีการละเมิดข้อมูลส่วนบุคคลเกิดขึ้นหรือไม่ </p><p className="font-normal text-sm text-[#171717]">เมื่อคุณมีความแน่นอนในระดับที่สมเหตุสมผลว่าเกิดขึ้นจริง โปรดโทรติดต่อสายด่วนสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) เพื่อหารือเกี่ยวกับเหตุการณ์ที่เกิดขึ้นโดยละเอียด และรับคำแนะนำเกี่ยวกับวิธีจัดการกับการละเมิดและบรรเทาผลกระทบที่อาจเกิดขึ้น</p><p className="font-normal text-sm text-[#171717]">โทร 02 111 8800 ในวันและเวลาทำการ เวลา 8:30-16:30 น. ยกเว้นวันหยุดและวันนักขัตฤกษ์ หากสายด่วนปิดให้บริการ คุณอาจต้องการรายงานการละเมิดทันที โดยสามารถทำได้ทางออนไลน์ได้ที่อีเมล saraban@pdpc.or.th คุณจะต้องรายงานการละเมิดภายใน 72 ชั่วโมงนับจากที่ทราบเรื่อง</p>',
        },
        {
            sequence: 7,
            name: 'q7',
            q_en: 'No, the breach does not involve the personal data of living individuals',
            q_th: 'การละเมิดไม่เกี่ยวข้องกับข้อมูลส่วนบุคคลของบุคคลที่มีชีวิต',
            text_en:
                '<p className="font-normal text-sm text-[#171717]">A personal data breach has not occurred. There is no requirement to notify the PDPC.</p>',
            text_th:
                '<p className="font-normal text-sm text-[#171717]">ยังไม่มีการละเมิดข้อมูลส่วนบุคคลเกิดขึ้น ไม่จำเป็นต้องแจ้งให้ สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) ทราบ',
        },
        {
            sequence: 8,
            name: 'q8',
            q_en: "There is likely to be a high risk to individuals' rights and freedoms",
            q_th: 'มีแนวโน้มจะมีความเสี่ยงสูงต่อสิทธิและเสรีภาพของบุคคล',
            text_en:
                '<p className="font-normal text-sm text-[#171717]">You need to tell the people affected by the breach without delay. You should inform them about any steps you are taking to mitigate the effects of the breach and provide them with advice on what to do to protect themselves.</p><p className="font-normal text-sm text-[#171717]">As you’ve made an assessment there is likely to be a high risk then you must also notify the PDPC. This must be done within 72 hours of becoming aware of the breach. You may ring helpline on 02 111 8800 for advice on how to manage the breach and mitigate its effect. During business hours, 8:30 a.m. - 4:30 p.m., except holidays and public holidays.</p><p className="font-normal text-sm text-[#171717]">If the helpline is closed, you may prefer to report the breach without delay. You can do this online by emailing saraban@pdpc.or.th</p>',
            text_th:
                '<p className="font-normal text-sm text-[#171717]">คุณต้องแจ้งให้ผู้ที่ได้รับผลกระทบจากการละเมิดทราบโดยเร็วที่สุด คุณควรแจ้งให้พวกเขาทราบเกี่ยวกับขั้นตอนใดๆ ที่คุณดำเนินการเพื่อบรรเทาผลกระทบจากการละเมิด และให้คำแนะนำแก่พวกเขาว่าต้องทำอย่างไรเพื่อปกป้องตนเอง</p><p className="font-normal text-sm text-[#171717]">เนื่องจากคุณได้ประเมินแล้วว่ามีความเสี่ยงสูง คุณจะต้องแจ้งให้ สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) ทราบด้วย โดยจะต้องดำเนินการภายใน 72 ชั่วโมงหลังจากทราบถึงการละเมิด คุณสามารถโทรติดต่อสายด่วนของ สคส. ได้ที่หมายเลข 02 111 8800 เพื่อรับคำแนะนำเกี่ยวกับวิธีจัดการกับการละเมิดและบรรเทาผลกระทบ ในวันและเวลาทำการ เวลา 8:30-16:30 น. ยกเว้นวันหยุดและวันนักขัตฤกษ์</p><p className="font-normal text-sm text-[#171717]">หากสายด่วนปิดให้บริการ คุณอาจต้องการรายงานการละเมิดทันที โดยสามารถแจ้งได้ทางออนไลน์ได้ที่อีเมล saraban@pdpc.or.th</p>',
        },
        {
            sequence: 9,
            name: 'q9',
            q_en: "It's unlikely that the breach will result in a risk to individuals",
            q_th: 'ไม่น่าจะเป็นไปได้ที่การละเมิดจะส่งผลให้เกิดความเสี่ยงต่อบุคคล',
            text_en:
                '<p className="font-normal text-sm text-[#171717]">You should keep an internal record of the breach including what happened, the effects of the breach and remedial actions taken. There is no requirement to notify the PDPC but you should keep a note of why you came to this decision.  If new information which affects the circumstances of this breach comes to light, you should reassess the risk and determine whether it becomes reportable at that point.</p>',
            text_th:
                '<p className="font-normal text-sm text-[#171717]">คุณควรเก็บบันทึกภายในเกี่ยวกับการละเมิด รวมถึงสิ่งที่เกิดขึ้น ผลกระทบของการละเมิด และการดำเนินการแก้ไขที่ดำเนินการ ไม่จำเป็นต้องแจ้ง สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) แต่คุณควรบันทึกเหตุผลของการตัดสินใจไว้ในบันทึกการละเมิดภายในของคุณด้วย หากมีข้อมูลใหม่ที่ส่งผลต่อสถานการณ์การละเมิดนี้ปรากฏขึ้น คุณควรประเมินความเสี่ยงอีกครั้ง และพิจารณาว่าจะต้องรายงานความเสี่ยงนั้นหรือไม่</p>',
        },
        {
            sequence: 10,
            name: 'q10',
            q_en: "It's likely that the breach will result in a risk to individuals",
            q_th: 'มีแนวโน้มว่าการละเมิดจะส่งผลให้เกิดความเสี่ยงต่อบุคคล',
            text_en:
                '<p className="font-normal text-sm text-[#171717]">As you’ve made an assessment that it is likely there will be a risk then you must notify the PDPC. This must be done within 72 hours of becoming aware of the breach.</p><p className="font-normal text-sm text-[#171717]">If you need urgent advice about how to manage the breach, ring helpline on 02 111 8800 during business hours, 8:30 a.m. - 4:30 p.m. If the helpline is closed, you may prefer to report the breach without delay. You can do this online by emailing saraban@pdpc.or.th</p>',
            text_th:
                '<p className="font-normal text-sm text-[#171717]">เนื่องจากคุณได้ประเมินแล้วว่ามีความเสี่ยง ดังนั้นคุณต้องแจ้งให้ สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) ทราบ โดยต้องดำเนินการภายใน 72 ชั่วโมงหลังจากทราบถึงการละเมิด</p><p className="font-normal text-sm text-[#171717]">หากคุณต้องการคำแนะนำเร่งด่วนเกี่ยวกับวิธีจัดการกับการละเมิด กรุณาโทร 02 111 8800 ได้ ในวันและเวลาทำการ เวลา 8:30-16:30 น. ยกเว้นวันหยุดและวันนักขัตฤกษ์ หากสายด่วนปิดให้บริการ คุณอาจต้องการรายงานการละเมิดทันที โดยสามารถทำได้ทางออนไลน์ได้ที่อีเมล saraban@pdpc.or.th</p>',
        },
        {
            sequence: 11,
            name: 'q11',
            q_en: 'Yes, the risk to the data subject has been mitigated',
            q_th: 'ความเสี่ยงต่อข้อมูลของเจ้าของข้อมูลได้รับการบรรเทาลงแล้ว',
            text_en:
                '<p className="font-normal text-sm text-[#171717]">Based on your assessment the likelihood of risk to data subjects appears to be unlikely, you should keep an internal record of the breach including what happened, the effects of the breach and remedial actions taken. There is no requirement to notify the PDPC but you should also record the reason for your decision in your internal breach record.  If new information which affects the circumstances of this breach comes to light, you should reassess the risk and whether it becomes reportable at that point.</p>',
            text_th:
                '<p className="font-normal text-sm text-[#171717]">จากการประเมินของคุณ พบว่าความน่าจะเป็นที่ข้อมูลจะมีความเสี่ยงนั้นไม่น่าจะเกิดขึ้น คุณควรเก็บบันทึกภายในเกี่ยวกับการละเมิด รวมถึงสิ่งที่เกิดขึ้น ผลกระทบของการละเมิด และการดำเนินการแก้ไขที่ดำเนินการ ไม่จำเป็นต้องแจ้ง สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) แต่คุณควรบันทึกเหตุผลของการตัดสินใจไว้ในบันทึกการละเมิดภายในของคุณด้วย หากมีข้อมูลใหม่ที่ส่งผลต่อสถานการณ์การละเมิดนี้ปรากฏขึ้น คุณควรประเมินความเสี่ยงอีกครั้ง และพิจารณาว่าจะต้องรายงานความเสี่ยงนั้นหรือไม่</p>',
        },
        {
            sequence: 12,
            name: 'q12',
            q_en: 'No, the risk to the data subject has not been mitigated',
            q_th: 'ความเสี่ยงต่อเจ้าของข้อมูลยังไม่ได้รับการบรรเทา',
            text_en:
                '<p className="font-normal text-sm text-[#171717]">Please ring helpline to discuss the breach in more detail. PDPC can offer advice on how to manage the breach and mitigate its effect. The helpline, on 02 111 8800 during business hours, 8:30 a.m. - 4:30 p.m. If the helpline is closed, you may prefer to report the breach without delay. </p><p className="font-normal text-sm text-[#171717]">You can do this online by emailing saraban@pdpc.or.th You are required to report breaches within 72 hours of becoming aware of them.</p>',
            text_th:
                '<p className="font-normal text-sm text-[#171717]">โปรดโทรติดต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.) เพื่อหารือเกี่ยวกับการละเมิดโดยละเอียด และรับคำแนะนำเกี่ยวกับวิธีจัดการการละเมิดและบรรเทาผลกระทบได้ โทร 02 111 8800 ในวันและเวลาทำการ เวลา 8:30-16:30 น. ยกเว้นวันหยุดและวันนักขัตฤกษ์</p><p className="font-normal text-sm text-[#171717]">หากสายด่วนปิดให้บริการ คุณอาจต้องการรายงานการละเมิดทันที โดยสามารถทำได้ทางออนไลน์ได้ที่อีเมล saraban@pdpc.or.th คุณจะต้องรายงานการละเมิดภายใน 72 ชั่วโมงนับจากที่ทราบเรื่อง</p>',
        },
    ];

    useEffect(() => {
        if (questionSequence > 0) {
            const result = [
                {
                    question: {
                        en: question[questionSequence].q_en,
                        th: question[questionSequence].q_th,
                    },
                    text: {
                        en: question[questionSequence].text_en,
                        th: question[questionSequence].text_th,
                    },
                },
            ];
            setTab1Result(result);
        }
    }, [questionSequence]);

    const checkQuestion = (qNo, data) => {
        const newQNo = qNo - 1;
        let sequence;
        if (newQNo !== -1) {
            const value = data[newQNo];
            switch (newQNo) {
                case 0:
                    if (Number(value.answer) === 2) {
                        sequence = 5;
                    } else if (Number(value.answer) === 3) {
                        sequence = 6;
                    }
                    setQuestionSequence(sequence);

                    return sequence;
                case 1:
                    if (Number(value.answer) === 2) {
                        sequence = 7;
                    }
                    setQuestionSequence(sequence);
                    return sequence;
                case 2:
                    if (Number(value.answer) === 1) {
                        sequence = 8;
                    }
                    setQuestionSequence(sequence);
                    return sequence;
                case 3:
                    if (Number(value.answer) === 2) {
                        sequence = 9;
                    } else if (Number(value.answer) === 3) {
                        sequence = 10;
                    }
                    setQuestionSequence(sequence);
                    return sequence;
                case 4:
                    if (Number(value.answer) === 1) {
                        sequence = 11;
                    } else if (Number(value.answer) === 2) {
                        sequence = 12;
                    }
                    setQuestionSequence(sequence);
                    return sequence;
            }
        }
    };

    const getSelfAssessment = () => {
        DataBreachService.getSelfAssessment(id).then(async (res) => {
            await checkQuestion(
                res?.data?.resultData.length,
                res?.data?.resultData
            );
        });
    };

    useEffect(async () => {
        await getDataBreachLogDetail(id);
    }, [id, triggerDetails]);

    const saveRename = (values) => {
        setLoadinSave(true);
        setChangeName(false);
        setIsRename(false);
        if (changeName) {
            const payload = {
                dataBreachLogId: id,
                name: values.name,
            };
            DataBreachService.renameDataBreachName(payload)
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        setOpenModalStatus(true);
                    } else {
                        setOpenModalStatus(false);
                    }
                    setLoadinSave(false);
                    // setChangeEdit(false);
                })
                .catch((err) => {
                    notify({
                        type: 'error',
                        title: t('Fail'),
                        description: t('FailedtoSubmitData'),
                        closeable: true,
                        timeOut: 120000,
                    });
                    setLoadinSave(false);
                });
        }
    };

    const saveOwner = async () => {
        try {
            const values = await formOwner.validateFields();
            setLoadingOwner(true);
            if (changeOwner) {
                const payload = {
                    txnDataBreachId: id,
                    assignee: values.owner,
                };
                DataBreachService.manualUpdate(payload)
                    .then((res) => {
                        if (res.data.resultMsg === 'SUCCESS') {
                            setOpenModalStatus(true);
                        } else {
                            setOpenModalStatus(false);
                        }
                        setLoadingOwner(false);
                        // setChangeEdit(false);
                    })
                    .catch((err) => {
                        notify({
                            type: 'error',
                            title: t('Fail'),
                            description: t('FailedtoSubmitData'),
                            closeable: true,
                            timeOut: 120000,
                        });
                        setLoadinSave(false);
                    });
            }
            setChangeOwner(false);
            setIsOwner(false);
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    const cancelRename = async () => {
        setChangeName(false);
        setIsRename(false);
        setField(dataBreachLogDetail);
    };

    const cancelOwner = async () => {
        setChangeOwner(false);
        setIsOwner(false);
        setField(dataBreachLogDetail);
    };

    const groupHeaders = [
        'ข้อมูลของผู้ร้องเรียน',
        'ข้อมูลเจ้าของข้อมูลส่วนบุคคล',
        'รายละเอียดเหตุละเมิดข้อมูลส่วนบุคคล',
    ];

    const groupManualHeaders = ['รายละเอียดเหตุละเมิดข้อมูลส่วนบุคคล'];
    const { getUserDetail, getDCDPO, getConsequence, getInformingDetail } =
        useDownlaod(id);

    const download = () => {
        const handleDCDPO = (answer, user, dcdpo) => {
            if (!answer || !user || !dcdpo) return;

            getInformingDetail().then((informing) => {
                const data = {
                    user,
                    dcdpo,
                    answer,
                    informing,
                };
                const { html } = HtmlToDoc(data);
                let blob = new Blob([html], {
                    type: 'text/html',
                });
                let url = URL.createObjectURL(blob);
                window.open(url);
            });
        };

        const handleUserDetail = (answer, userDetail) => {
            getDCDPO().then((dcdpo) => handleDCDPO(answer, userDetail, dcdpo));
        };

        const handleConsequence = (answer) => {
            getUserDetail().then((userDetail) =>
                handleUserDetail(answer, userDetail)
            );
        };

        getConsequence().then(handleConsequence);
    };

    return (
        <div className="bg-gray-body ">
            {/* <HeaderLayout /> */}

            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() => navigate(`${ROUTER.DATA_BREACH.LOG}`)}
                >
                    <IconBack />
                </button>
                {t('Data Breach Log Details')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Data Breach')} / {t('Data Breach Log')} /
                </span>
                <span className="text-[#65707A]">
                    {' '}
                    {t('Data Breach Log Details')}
                </span>
            </div>
            <div className="grid grid-cols-4">
                <div className="col-span-1">
                    <Collapse title={t('Incident details')}>
                        <div className="pb-2">
                            <span className="text-gray-dark text-sm	font-semibold">
                                {t('Incident Number')} :{' '}
                            </span>
                            <span className="text-gray-dark text-sm">
                                {dataBreachLogDetail.dataBreachEventNumber}
                            </span>
                        </div>
                        <div className="pb-2">
                            <span className="text-gray-dark text-sm	font-semibold">
                                {t('Incident Status')} :{' '}
                            </span>
                            <span className="text-gray-dark text-sm">
                                {dataBreachLogDetail.statusEn === 'New' ? (
                                    <Tag className="rounded-xl -my-1 text-center bg-[#1890FF] border-[#1890FF] text-white">
                                        {lang === 'en'
                                            ? dataBreachLogDetail.statusEn
                                            : dataBreachLogDetail.statusTh}
                                    </Tag>
                                ) : dataBreachLogDetail.statusEn ===
                                    'Resolved' ? (
                                    <Tag className="rounded-xl -my-1 text-center bg-[#4ACE8F] border-[#4ACE8F] text-white">
                                        {lang === 'en'
                                            ? dataBreachLogDetail.statusEn
                                            : dataBreachLogDetail.statusTh}
                                    </Tag>
                                ) : dataBreachLogDetail.statusEn ===
                                    'Under Management' ? (
                                    <Tag className="rounded-xl -my-1 text-center bg-[#F9C153] border-[#F9C153] text-white">
                                        {lang === 'en'
                                            ? dataBreachLogDetail.statusEn
                                            : dataBreachLogDetail.statusTh}
                                    </Tag>
                                ) : (
                                    <Tag className="rounded-xl -my-1 text-center bg-[#F0536F] border-[#F0536F] text-white">
                                        {lang === 'en'
                                            ? dataBreachLogDetail.statusEn
                                            : dataBreachLogDetail.statusTh}
                                    </Tag>
                                )}
                            </span>
                        </div>
                        <div className="pb-2">
                            <span className="text-gray-dark text-sm	font-semibold">
                                {t('Please complete the process within')} :{' '}
                            </span>
                            <span className="text-gray-dark text-sm">
                                {dataBreachLogDetail.targetDate}
                            </span>
                        </div>
                        <div className="pb-2">
                            <span className="text-gray-dark text-sm	font-semibold">
                                {t('Incident')} :{' '}
                            </span>
                            <div className="text-gray-dark text-sm">
                                <Form
                                    scrollToFirstError={{
                                        behavior: 'smooth',
                                        block: 'center',
                                    }}
                                    onFinish={saveRename}
                                    form={form}
                                    className="w-full"
                                    layout="vertical"
                                    onFieldsChange={(_, allFields) => {
                                        if (allFields.length > 0) {
                                            setChangeName(true);
                                        }
                                    }}
                                >
                                    <div className="flex">
                                        <Form.Item
                                            label={false}
                                            name="name"
                                            className="mb-0 w-full pt-2"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t('requiredField'),
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="large"
                                                showCount
                                                maxLength={100}
                                                disabled={!isRename}
                                            />
                                        </Form.Item>
                                        {userPermission.viewEdit &&
                                            dataBreachLogDetail.statusEn !==
                                            'New' &&
                                            dataBreachLogDetail.statusEn !==
                                            'Reject' &&
                                            dataBreachLogDetail.statusEn !==
                                            'Resolved' && (
                                                <div className="flex items-center pt-2">
                                                    {isRename ? (
                                                        <div className="flex items-center rename-butt">
                                                            <button
                                                                loading={loadinSave}
                                                                disabled={!changeName}
                                                                htmlType="submit"
                                                                className={`text-blue-400 hover:opacity-80 font-semibold ${changeName ? 'cursor-pointer' : 'cursor-not-allowed'
                                                                    }`}
                                                            >
                                                                {t('Save')}
                                                            </button>
                                                            <span
                                                                className="flex items-center text-[#95A0A8] font-semibold pl-2 cursor-pointer hover:text-[#ff4d4f]"
                                                                onClick={() =>
                                                                    cancelRename()
                                                                }
                                                            >
                                                                {t('Cancel')}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <span
                                                            className="flex items-center text-[#1890FF] font-semibold pl-1 cursor-pointer"
                                                            onClick={() =>
                                                                setIsRename(
                                                                    true
                                                                )
                                                            }
                                                        >
                                                            {t('Edit')}
                                                        </span>
                                                    )}
                                                </div>
                                            )}
                                    </div>
                                </Form>
                            </div>
                        </div>

                        {isManual &&
                            dataBreachLogDetail.statusEn !== 'Reject' &&
                            dataBreachLogDetail.statusEn !== 'Resolved' ? (
                            <div className="pb-2">
                                <div className="flex justify-between">
                                    <span className="text-gray-dark text-sm	font-semibold">
                                        {t('Investigator')} :{' '}
                                    </span>
                                    {userPermission.viewEdit &&
                                        dataBreachLogDetail.statusEn !==
                                        'Reject' &&
                                        dataBreachLogDetail.statusEn !==
                                        'Resolved' && (
                                            <div className="flex items-center">
                                                {isOwner ? (
                                                    <div className="flex items-center rename-butt">
                                                        <button
                                                            loading={loadingOwner}
                                                            disabled={!changeOwner}
                                                            type="button"
                                                            onClick={() =>
                                                                saveOwner()
                                                            }
                                                            className={`text-blue-400 hover:opacity-80 font-semibold ${changeOwner ? 'cursor-pointer' : 'cursor-not-allowed'
                                                            }`}
                                                        >
                                                            {t('Save')}
                                                        </button>
                                                        <span
                                                            className="flex items-center text-[#95A0A8] font-semibold pl-2 cursor-pointer hover:text-[#ff4d4f]"
                                                            onClick={() =>
                                                                cancelOwner()
                                                            }
                                                        >
                                                            {t('Cancel')}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <span
                                                        className="flex items-center text-[#1890FF] font-semibold pl-1 cursor-pointer"
                                                        onClick={() =>
                                                            setIsOwner(true)
                                                        }
                                                    >
                                                        {t('Edit')}
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                </div>

                                <div className="text-gray-dark text-sm">
                                    <Form
                                        scrollToFirstError={{
                                            behavior: 'smooth',
                                            block: 'center',
                                        }}
                                        onFinish={saveOwner}
                                        form={formOwner}
                                        className="w-full"
                                        layout="vertical"
                                    >
                                        <div className="flex">
                                            <Form.Item
                                                label={false}
                                                name="owner"
                                                className="mb-0 w-full pt-2"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            t('requiredField'),
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    size="large"
                                                    mode="multiple"
                                                    placeholder={t(
                                                        'Select the Responsible Person'
                                                    )}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        (option?.children ?? '')
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                    disabled={!isOwner}
                                                    maxCount={3}
                                                    value={selectedReviewer}
                                                    onChange={(
                                                        selectedValues
                                                    ) => {
                                                        if (
                                                            selectedValues.length <=
                                                            3
                                                        ) {
                                                            setChangeOwner(
                                                                selectedValues
                                                            );
                                                            setSelectedReviewer(
                                                                selectedValues
                                                            );
                                                        }
                                                    }}
                                                    suffixIcon={suffix}
                                                >
                                                    {userOptions.map((item) => (
                                                        <Select.Option
                                                            key={item.userId}
                                                            value={item.userId}
                                                            disabled={
                                                                selectedReviewer.length >=
                                                                3 &&
                                                                !selectedReviewer.includes(
                                                                    item.userId
                                                                )
                                                            }
                                                        >
                                                            {item.fullName}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        ) : (
                            <div className="pb-2">
                                <span className="text-gray-dark text-sm	font-semibold">
                                    {t('Investigator')} :{' '}
                                </span>
                                <ul className="list-disc mb-0">
                                    {dataBreachLogDetail.investigator
                                        ?.split(',')
                                        .map((investigator, index) => (
                                            <li
                                                key={index}
                                                className="text-[#121330] text-sm"
                                            >
                                                {investigator.trim()}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        )}
                        {dataBreachLogDetail.statusEn === 'Reject' && (
                            <>
                                <div className="pb-2">
                                    <span className="text-gray-dark text-sm	font-semibold">
                                        {t('Reason for rejection')} :{' '}
                                    </span>
                                    <span className="text-gray-dark text-sm">
                                        {dataBreachLogDetail.reason}
                                    </span>
                                </div>
                                <div className="pb-2">
                                    <span className="text-gray-dark text-sm	font-semibold">
                                        {t('Rejected by')} :{' '}
                                    </span>
                                    <span className="text-gray-dark text-sm">
                                        {dataBreachLogDetail.reviewBy}
                                    </span>
                                </div>
                                <div className="pb-2">
                                    <span className="text-gray-dark text-sm	font-semibold">
                                        {t('Rejected date')} :{' '}
                                    </span>
                                    <span className="text-gray-dark text-sm">
                                        {dataBreachLogDetail.modifyDate}
                                    </span>
                                </div>
                            </>
                        )}
                        {dataBreachLogDetail.statusEn === 'Resolved' && (
                            <>
                                <div className="pb-2">
                                    <span className="text-gray-dark text-sm	font-semibold">
                                        {t('Resolved by')} :{' '}
                                    </span>
                                    <span className="text-gray-dark text-sm">
                                        {dataBreachLogDetail.reviewBy}
                                    </span>
                                </div>
                                <div className="pb-2">
                                    <span className="text-gray-dark text-sm	font-semibold">
                                        {t('Resolved date')} :{' '}
                                    </span>
                                    <span className="text-gray-dark text-sm">
                                        {dataBreachLogDetail.modifyDate}
                                    </span>
                                </div>
                            </>
                        )}
                        {/* trigger isManual*/}

                        <div className="flex justify-start pt-4">
                            {userPermission.reject &&
                                (dataBreachLogDetail.statusEn === 'New' ||
                                    dataBreachLogDetail.statusEn ===
                                    'Under Management') && (
                                    <Button
                                        size="large"
                                        type="default"
                                        className="text-purple-PHX border-purple-PHX w-full"
                                        onClick={() => rejectForm()}
                                        style={{
                                            width: 'fit-content',
                                            marginRight: 10,
                                        }}
                                    >
                                        {t('Reject operation')}
                                    </Button>
                                )}
                            {userPermission.viewEdit &&
                                dataBreachLogDetail.statusEn === 'New' && (
                                    <Button
                                        loading={loadinSave}
                                        size="large"
                                        type="primary"
                                        className="w-full"
                                        onClick={() => startForm()}
                                        style={{ width: 'fit-content' }}
                                    >
                                        {t('Start operation')}
                                    </Button>
                                )}
                            {userPermission.complete}
                            {userPermission.complete &&
                                dataBreachLogDetail.statusEn ===
                                'Under Management' && (
                                    <Button
                                        loading={loadinSave}
                                        size="large"
                                        type="primary"
                                        className="w-full"
                                        onClick={() =>
                                            setOpenConfirmComplete(true)
                                        }
                                        style={{ width: 'fit-content' }}
                                    >
                                        {t('Resolve')}
                                    </Button>
                                )}
                        </div>
                    </Collapse>

                    {/* Donwload */}
                    <div className="rounded-lg bg-white px-4 py-2 mt-6">
                        <p className="text-[#7B67FB] flex items-center space-x-2 text-xl font-semibold">
                            {t('Personal Data Breach Notification Letter')}
                        </p>
                        <p className="font-semibold">
                            {t(
                                'For your convenience, the system automatically generates a personal data breach notification letter'
                            )}
                        </p>
                        <button
                            onClick={download}
                            disabled={!(isHaveSelf && isHaveConsequence)}
                            className="flex items-center text-[#1890FF] gap-2 pb-2 disabled:opacity-50 disabled:text-gray-400 disabled:cursor-not-allowed"
                        >
                            <DownloadOutlined />
                            <u>{t('Download')}</u>
                        </button>
                        <p className="text-[#65707A]">
                            {t('descriptionDownload')}
                        </p>
                    </div>

                    <Collapse title={t('Reporting information')}>
                        <ul className="list-disc pl-0">
                            {jsonDetail?.groupQuestion?.map(
                                (group, groupIndex) => {
                                    if (groupIndex === 3) return null;

                                    return (
                                        // {

                                        // }
                                        <div key={groupIndex} className="mb-2">
                                            <h3 className="text-[#171717] font-semibold	text-base mb-2">
                                                {group[groupIndex]
                                                    ? groupHeaders[groupIndex]
                                                    : groupManualHeaders[
                                                    groupIndex
                                                    ]}
                                            </h3>
                                            <ul className="list-disc mb-0-breach">
                                                {group.map((item, index) => (
                                                    <li
                                                        key={index}
                                                        className="mt-2"
                                                    >
                                                        <div
                                                            className={
                                                                groupIndex === 2
                                                                    ? `flex flex-col`
                                                                    : `flex`
                                                            }
                                                        >
                                                            <span
                                                                className={
                                                                    item.questionName.includes(
                                                                        'บทบาทผู้ยื่นคำร้อง'
                                                                    )
                                                                        ? `text-sm font-semibold text-[#171717] basis-2/5`
                                                                        : `text-sm font-semibold text-[#171717]`
                                                                }
                                                            >
                                                                {parse(
                                                                    item.questionName
                                                                )}
                                                            </span>

                                                            <span>
                                                                {groupIndex !==
                                                                    2 && (
                                                                        <span className="px-1">
                                                                            :
                                                                        </span>
                                                                    )}{' '}
                                                                {item.value ||
                                                                    '-'}
                                                            </span>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    );
                                }
                            )}
                        </ul>
                    </Collapse>
                </div>
                <div className="w-full m-auto col-span-3 ml-2 h-full">
                    <div
                        className="content bg-white p-8 mt-6"
                        style={{ borderRadius: '6px' }}
                    >
                        <div className="content pb-3">
                            <Tabs
                                onChange={(key) => {
                                    navigate(
                                        `${ROUTER.DATA_BREACH.LOG_FORM}/${id}?tab=${key}`
                                    );
                                }}
                                activeKey={params.get('tab') || '0'}
                                className="data-breach-log"
                            >
                                <TabPane tab={t('Self assessment')} key={0}>
                                    <Tab1
                                        details={id}
                                        permission={userPermission}
                                        triggerDetails={triggerDetails}
                                        setTriggerDetails={setTriggerDetails}
                                        dataBreachLogDetail={
                                            dataBreachLogDetail
                                        }
                                        question={question}
                                    />
                                </TabPane>
                                <TabPane
                                    tab={
                                        <div className="flex  items-stretch">
                                            <div className="mb-0 self-center">
                                                {t('Consequences')}
                                            </div>
                                            {validateTab2 && (
                                                <svg
                                                    className="ml-2 self-start"
                                                    width="10"
                                                    height="10"
                                                    viewBox="0 0 10 10"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle
                                                        cx="5"
                                                        cy="5"
                                                        r="5"
                                                        fill="#F0536F"
                                                    />
                                                </svg>
                                            )}
                                        </div>
                                    }
                                    key={1}
                                >
                                    <Tab2
                                        details={id}
                                        permission={userPermission}
                                        tab2Form={tab2Form}
                                        consequence={consequence}
                                        consequenceConvert={consequenceConvert}
                                        triggerDetails={triggerDetails}
                                        setTriggerDetails={setTriggerDetails}
                                        dataBreachLogDetail={
                                            dataBreachLogDetail
                                        }
                                        viewMode={viewMode}
                                        setViewMode={setViewMode}
                                        validateTab2={validateTab2}
                                    />
                                </TabPane>
                                <TabPane
                                    tab={
                                        <div className="flex  items-stretch">
                                            <div className="mb-0 self-center">
                                                {t(
                                                    'Action Plan and Remediation'
                                                )}
                                            </div>
                                            {validateTab3 && (
                                                <svg
                                                    className="ml-2 self-start"
                                                    width="10"
                                                    height="10"
                                                    viewBox="0 0 10 10"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle
                                                        cx="5"
                                                        cy="5"
                                                        r="5"
                                                        fill="#F0536F"
                                                    />
                                                </svg>
                                            )}
                                        </div>
                                    }
                                    key={2}
                                >
                                    <Tab3
                                        details={id}
                                        permission={userPermission}
                                        triggerDetails={triggerDetails}
                                        setTriggerDetails={setTriggerDetails}
                                        dataBreachLogDetail={
                                            dataBreachLogDetail
                                        }
                                        actionData={actionData}
                                    />
                                </TabPane>
                                <TabPane
                                    tab={
                                        <div className="flex  items-stretch">
                                            <div className="mb-0 self-center">
                                                {t('Incident Notification')}
                                            </div>
                                            {validateTab4 && (
                                                <svg
                                                    className="ml-2 self-start"
                                                    width="10"
                                                    height="10"
                                                    viewBox="0 0 10 10"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle
                                                        cx="5"
                                                        cy="5"
                                                        r="5"
                                                        fill="#F0536F"
                                                    />
                                                </svg>
                                            )}
                                        </div>
                                    }
                                    key={3}
                                >
                                    <Tab4
                                        details={id}
                                        permission={userPermission}
                                        triggerDetails={triggerDetails}
                                        setTriggerDetails={setTriggerDetails}
                                        dataBreachLogDetail={
                                            dataBreachLogDetail
                                        }
                                        tab4Form={tab4Form}
                                        viewMode4={viewMode4}
                                        setViewMode4={setViewMode4}
                                        validateTab4={validateTab4}
                                        tab1Result={tab1Result}
                                    />
                                </TabPane>
                                <TabPane tab={t('Related Files')} key={4}>
                                    <Tab5
                                        details={id}
                                        permission={userPermission}
                                        status={dataBreachLogDetail.statusEn}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>

            {openModalStatus && (
                <ModalSuccess
                    open={openModalStatus}
                    handelClose={() => {
                        setOpenModalStatus(undefined);
                        setEditFlag(false);
                        // setViewMode(true);
                    }}
                    handelOk={() => {
                        setOpenModalStatus(undefined);
                        setEditFlag(false);
                        // setViewMode(true);
                    }}
                    text={t('Successfully saved data')}
                />
            )}
            <ModalFail
                open={openModalStatus === false}
                handelClose={() => {
                    setOpenModalStatus(undefined);
                }}
                handelOk={() => {
                    setOpenModalStatus(undefined);
                }}
                text={t('Failed to submit data')}
            />
            <ModalDiscardChanges
                open={editFlag}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => keepEditing()}
            />
            <ModalConfirm
                title={t('Do you want to proceed')}
                text={t('The task status will be changed to In Progress')}
                icon={
                    <svg
                        width="169"
                        height="119"
                        viewBox="0 0 169 119"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_1461_12463)">
                            <path
                                d="M86.2409 118.747C91.3197 118.747 95.4368 114.63 95.4368 109.551C95.4368 104.473 91.3197 100.355 86.2409 100.355C81.1621 100.355 77.0449 104.473 77.0449 109.551C77.0449 114.63 81.1621 118.747 86.2409 118.747Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M141.178 118.231C146.322 116.686 151.792 115.075 155.872 111.402C159.518 108.12 161.979 103.108 160.469 98.1854C158.961 93.2732 154.446 89.9977 149.785 88.3686C147.141 87.4447 144.375 86.932 141.61 86.5294C138.605 86.0916 135.586 85.733 132.568 85.3878C120.35 83.9904 108.086 83.1367 95.7757 82.8268C89.7014 82.6738 83.6283 82.6775 77.5532 82.7657C72.1277 82.8444 66.4136 82.8425 61.3805 80.5365C57.4665 78.7434 53.9142 75.481 52.8236 71.1939C51.5647 66.2452 53.8867 61.2056 57.2176 57.6215C58.9734 55.7323 61.0254 54.1423 63.1423 52.6802C65.4388 51.0941 67.8153 49.6203 70.2433 48.2445C75.0255 45.5363 80.025 43.2314 85.1901 41.3538C87.7381 40.4274 90.3239 39.628 92.9322 38.8906C95.1346 38.268 97.3439 37.6444 99.4725 36.7961C103.587 35.156 107.501 32.378 108.547 27.8237C109.539 23.5073 107.867 18.8216 104.936 15.615C101.545 11.9052 96.4319 10.279 91.5299 10.0158C86.0267 9.72044 80.6502 11.0978 75.4776 12.8458C69.9607 14.7102 64.5627 16.8539 58.9292 18.364C53.3429 19.86 47.6484 20.9185 41.8976 21.5299C39.0824 21.8297 36.1821 22.1682 33.3501 21.9387C30.9766 21.7463 28.6153 21.0483 26.8661 19.3639C25.3663 17.9196 24.4728 15.9346 24.78 13.8398C24.8358 13.4594 25.4137 13.6211 25.3583 13.9993C24.9844 16.5492 26.7177 18.8988 28.8536 20.1024C31.3221 21.4935 34.326 21.4954 37.0743 21.3363C43.0335 20.9764 48.9523 20.1208 54.7695 18.7783C60.4854 17.4728 65.9973 15.6064 71.5029 13.6128C76.7318 11.7193 82.0776 9.87124 87.6638 9.46112C92.5109 9.10527 97.6097 9.81141 101.832 12.3445C105.544 14.5707 108.273 18.2833 109.142 22.5436C109.992 26.7067 108.815 30.897 105.664 33.8021C102.401 36.81 97.9269 38.096 93.7576 39.2804C88.4694 40.7826 83.2947 42.5386 78.2859 44.8186C73.2088 47.1231 68.3396 49.8606 63.7322 53.0006C59.285 56.0397 54.896 59.8637 53.4894 65.2855C52.8342 67.811 52.9552 70.4896 54.0515 72.8751C55.0263 74.9961 56.6317 76.7803 58.5019 78.1564C62.9641 81.4399 68.588 82.114 73.9779 82.1811C80.0316 82.2564 86.0854 82.0521 92.141 82.1515C104.482 82.3541 116.798 83.1052 129.088 84.4051C132.168 84.731 135.244 85.0913 138.316 85.486C141.079 85.841 143.851 86.1938 146.568 86.8243C151.398 87.9455 156.099 90.1012 159.101 94.1967C160.433 95.9719 161.259 98.0756 161.489 100.283C161.699 102.587 161.135 104.895 160.094 106.944C157.788 111.481 153.47 114.366 148.884 116.261C146.428 117.277 143.88 118.046 141.337 118.809C140.967 118.921 140.808 118.342 141.178 118.231L141.178 118.231Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M25.168 18.6915C27.8178 18.6915 29.9659 16.5434 29.9659 13.8936C29.9659 11.2438 27.8178 9.0957 25.168 9.0957C22.5182 9.0957 20.3701 11.2438 20.3701 13.8936C20.3701 16.5434 22.5182 18.6915 25.168 18.6915Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M58.4532 27.7882C61.103 27.7882 63.2511 25.6401 63.2511 22.9903C63.2511 20.3405 61.103 18.1924 58.4532 18.1924C55.8034 18.1924 53.6553 20.3405 53.6553 22.9903C53.6553 25.6401 55.8034 27.7882 58.4532 27.7882Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M86.6407 9.59578C89.2905 9.59578 91.4386 7.44769 91.4386 4.79789C91.4386 2.14809 89.2905 0 86.6407 0C83.9909 0 81.8428 2.14809 81.8428 4.79789C81.8428 7.44769 83.9909 9.59578 86.6407 9.59578Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M104.232 29.9864C106.882 29.9864 109.03 27.8383 109.03 25.1885C109.03 22.5387 106.882 20.3906 104.232 20.3906C101.583 20.3906 99.4346 22.5387 99.4346 25.1885C99.4346 27.8383 101.583 29.9864 104.232 29.9864Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M80.4434 53.5762C83.0932 53.5762 85.2413 51.4282 85.2413 48.7784C85.2413 46.1286 83.0932 43.9805 80.4434 43.9805C77.7936 43.9805 75.6455 46.1286 75.6455 48.7784C75.6455 51.4282 77.7936 53.5762 80.4434 53.5762Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M50.2559 64.9718C52.9057 64.9718 55.0538 62.8237 55.0538 60.1739C55.0538 57.5241 52.9057 55.376 50.2559 55.376C47.6061 55.376 45.458 57.5241 45.458 60.1739C45.458 62.8237 47.6061 64.9718 50.2559 64.9718Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M82.2422 82.7638C84.892 82.7638 87.0401 80.6157 87.0401 77.9659C87.0401 75.3161 84.892 73.168 82.2422 73.168C79.5924 73.168 77.4443 75.3161 77.4443 77.9659C77.4443 80.6157 79.5924 82.7638 82.2422 82.7638Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M116.628 92.7589C119.278 92.7589 121.426 90.6108 121.426 87.961C121.426 85.3112 119.278 83.1631 116.628 83.1631C113.978 83.1631 111.83 85.3112 111.83 87.961C111.83 90.6108 113.978 92.7589 116.628 92.7589Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M156.81 90.5606C159.459 90.5606 161.608 88.4125 161.608 85.7627C161.608 83.1129 159.459 80.9648 156.81 80.9648C154.16 80.9648 152.012 83.1129 152.012 85.7627C152.012 88.4125 154.16 90.5606 156.81 90.5606Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M85.2557 13.5944C70.8837 13.696 59.116 25.3752 58.9118 39.7462C58.9099 39.8789 58.9091 40.8118 58.9092 42.0321C58.9093 43.8212 59.62 45.537 60.8851 46.8021C62.1501 48.0672 63.8659 48.7781 65.655 48.7783C66.5419 48.7781 67.4201 48.6031 68.2393 48.2634C69.0586 47.9237 69.8028 47.4259 70.4296 46.7985C71.0564 46.171 71.5534 45.4262 71.8922 44.6066C72.231 43.7869 72.405 42.9086 72.4043 42.0217C72.4036 41.1917 72.4032 40.6172 72.4032 40.5819C72.4027 38.3609 72.9804 36.178 74.0795 34.248C75.1785 32.3179 76.7611 30.7073 78.6714 29.5744C80.5818 28.4415 82.7542 27.8254 84.9748 27.7867C87.1955 27.748 89.388 28.2881 91.3367 29.3538C93.2853 30.4195 94.923 31.9741 96.0886 33.8647C97.2542 35.7552 97.9075 37.9167 97.9844 40.1364C98.0613 42.3561 97.559 44.5575 96.527 46.5242C95.495 48.4909 93.9688 50.1551 92.0986 51.353L92.1009 51.3559C92.1009 51.3559 82.4995 57.5371 79.5722 66.0165L79.5747 66.0171C79.06 67.7542 78.7992 69.5566 78.8004 71.3684C78.8004 72.1131 78.8442 78.6294 78.9288 83.9184C78.9584 85.7433 79.7043 87.4834 81.0054 88.7633C82.3065 90.0432 84.0587 90.7603 85.8838 90.7598C86.8009 90.7598 87.7089 90.5784 88.5556 90.2261C89.4023 89.8739 90.171 89.3576 90.8175 88.7071C91.4639 88.0566 91.9754 87.2848 92.3224 86.4359C92.6694 85.587 92.8452 84.6778 92.8395 83.7608C92.8101 78.9171 92.7942 73.2771 92.7942 72.8677C92.7942 67.661 97.8171 62.4733 101.943 59.0903C106.694 55.1946 110.113 49.8857 111.486 43.8971C111.79 42.6642 111.958 41.4016 111.986 40.1321C111.986 36.6309 111.293 33.1643 109.947 29.932C108.602 26.6998 106.63 23.7658 104.145 21.299C101.66 18.8322 98.7121 16.8815 95.4702 15.5592C92.2283 14.2369 88.7568 13.5692 85.2557 13.5944Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M168.623 119H0.23832C0.17531 119 0.114944 118.975 0.0704529 118.931C0.0259621 118.886 0.000976562 118.825 0.000976562 118.762C0.000976562 118.699 0.0259621 118.639 0.0704529 118.594C0.114944 118.55 0.17531 118.525 0.23832 118.524H168.623C168.686 118.524 168.747 118.549 168.791 118.594C168.836 118.639 168.861 118.699 168.861 118.762C168.861 118.826 168.836 118.886 168.791 118.931C168.747 118.975 168.686 119 168.623 119Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M125.635 54.5748C128.947 54.5748 131.632 51.8897 131.632 48.5774C131.632 45.2652 128.947 42.5801 125.635 42.5801C122.323 42.5801 119.638 45.2652 119.638 48.5774C119.638 51.8897 122.323 54.5748 125.635 54.5748Z"
                                fill="#171717"
                            />
                            <path
                                d="M114.552 116.374H112.102L110.936 106.921H114.553L114.552 116.374Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M110.351 115.674H115.078V118.65H107.375C107.375 118.259 107.452 117.872 107.602 117.511C107.751 117.15 107.97 116.822 108.247 116.546C108.523 116.269 108.851 116.05 109.212 115.9C109.573 115.751 109.96 115.674 110.351 115.674Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M133.544 116.374H131.093L129.927 106.921H133.544L133.544 116.374Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M129.342 115.674H134.069V118.65H126.366C126.366 118.259 126.443 117.872 126.593 117.511C126.742 117.15 126.962 116.822 127.238 116.546C127.514 116.269 127.842 116.05 128.203 115.9C128.564 115.751 128.951 115.674 129.342 115.674Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M124.723 54.6101C127.434 54.6101 129.633 52.4118 129.633 49.7001C129.633 46.9883 127.434 44.79 124.723 44.79C122.011 44.79 119.812 46.9883 119.812 49.7001C119.812 52.4118 122.011 54.6101 124.723 54.6101Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M127.65 70.4503L129.847 65.4025C130.381 64.2184 130.534 62.8978 130.285 61.6231C130.036 60.3483 129.397 59.1822 128.458 58.2857C128.265 58.0949 128.06 57.9166 127.844 57.7519C126.76 56.9039 125.424 56.4417 124.048 56.4385C123.122 56.4421 122.209 56.6453 121.369 57.0342C121.297 57.0662 121.227 57.1002 121.155 57.1342C121.017 57.2001 120.881 57.2721 120.749 57.3461C119.888 57.8402 119.156 58.5297 118.611 59.359C118.066 60.1882 117.723 61.134 117.61 62.12L116.641 70.2444C116.397 70.8821 107.697 93.912 110.74 111.494C110.772 111.682 110.863 111.855 111.001 111.987C111.138 112.119 111.314 112.203 111.503 112.228L114.588 112.648C114.813 112.679 115.042 112.623 115.227 112.492C115.413 112.361 115.543 112.165 115.589 111.942L120.765 87.2709C120.797 87.1176 120.88 86.9796 121 86.8788C121.12 86.7781 121.27 86.7205 121.427 86.7152C121.583 86.7099 121.737 86.7572 121.864 86.8496C121.99 86.942 122.082 87.0742 122.124 87.225L129.437 113.17C129.489 113.358 129.602 113.524 129.758 113.643C129.913 113.761 130.103 113.825 130.299 113.825C130.357 113.825 130.415 113.82 130.473 113.809L134.241 113.084C134.46 113.043 134.656 112.921 134.79 112.743C134.925 112.566 134.988 112.344 134.967 112.122C134.413 105.947 131.47 75.0143 127.65 70.4503Z"
                                fill="#171717"
                            />
                            <path
                                d="M105.641 53.7862C105.607 54.0781 105.638 54.3739 105.73 54.6528C105.823 54.9317 105.976 55.1869 106.178 55.4005C106.379 55.614 106.626 55.7807 106.899 55.8887C107.172 55.9968 107.466 56.0436 107.759 56.0258L110.504 62.6214L112.58 59.5439L109.655 53.7525C109.593 53.2616 109.353 52.8107 108.98 52.4852C108.607 52.1597 108.128 51.9822 107.634 51.9864C107.139 51.9906 106.663 52.1761 106.296 52.5078C105.928 52.8395 105.696 53.2943 105.641 53.7861L105.641 53.7862Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M124.451 77.0912C124.743 77.0563 125.023 76.9579 125.273 76.8028C125.523 76.6477 125.735 76.4398 125.896 76.1937C126.056 75.9476 126.161 75.6692 126.202 75.3783C126.244 75.0873 126.221 74.7908 126.135 74.5097L131.91 70.3038L128.433 69.002L123.483 73.1955C123.02 73.3706 122.637 73.7093 122.408 74.1476C122.178 74.5858 122.117 75.0931 122.236 75.5733C122.356 76.0535 122.647 76.4732 123.055 76.753C123.463 77.0327 123.96 77.1531 124.451 77.0912Z"
                                fill="#A0616A"
                            />
                            <path
                                d="M115.037 67.0184C114.816 67.0182 114.595 66.9964 114.378 66.9534C113.853 66.8534 113.36 66.6258 112.944 66.2905C112.527 65.9553 112.2 65.5227 111.99 65.031L108.144 60.3424C108.063 60.2433 108.004 60.1279 107.971 60.0041C107.938 59.8802 107.932 59.7507 107.953 59.6243C107.974 59.4978 108.021 59.3773 108.093 59.2708C108.164 59.1643 108.258 59.0743 108.367 59.0069L111.102 57.3135C111.203 57.2509 111.316 57.209 111.433 57.1901C111.55 57.1713 111.67 57.1758 111.786 57.2035C111.901 57.2312 112.01 57.2815 112.106 57.3515C112.202 57.4215 112.283 57.5098 112.345 57.6114L115.055 62.0762L120.245 58.2406C120.658 58.0239 121.135 57.9632 121.59 58.0694C122.044 58.1756 122.445 58.4418 122.719 58.8192C122.994 59.1967 123.123 59.6602 123.084 60.1251C123.045 60.5901 122.839 61.0254 122.506 61.3515L117.326 66.0768C116.717 66.6802 115.895 67.0186 115.037 67.0184Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M129.061 74.0705C129.054 74.0705 129.047 74.0705 129.04 74.0703C128.914 74.0673 128.79 74.0377 128.676 73.9837C128.562 73.9296 128.46 73.8522 128.378 73.7564L125.946 70.919C125.863 70.8224 125.802 70.7092 125.766 70.5871C125.73 70.465 125.721 70.3367 125.738 70.2106C125.755 70.0845 125.799 69.9635 125.867 69.8557C125.934 69.7479 126.024 69.6556 126.13 69.585L130.684 66.5488L126.559 61.5885C126.319 61.1884 126.23 60.7153 126.31 60.2556C126.39 59.7959 126.633 59.3804 126.994 59.0849C127.355 58.7894 127.811 58.6337 128.277 58.6462C128.744 58.6587 129.19 58.8386 129.535 59.1531L134.549 64.0534C134.944 64.414 135.245 64.8649 135.427 65.3675C135.609 65.8701 135.667 66.4094 135.594 66.939C135.522 67.4686 135.322 67.9728 135.012 68.4083C134.702 68.8438 134.291 69.1975 133.814 69.4392L129.716 73.788C129.632 73.8772 129.53 73.9482 129.418 73.9968C129.305 74.0454 129.184 74.0705 129.061 74.0705Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M123.475 63.6148C123.436 63.6148 123.397 63.6123 123.358 63.6074C123.189 63.5868 123.029 63.518 122.897 63.4093C122.766 63.3006 122.668 63.1564 122.616 62.9939L120.789 57.3905C120.743 57.2488 120.75 57.0954 120.808 56.9585C120.867 56.8216 120.973 56.7106 121.107 56.6459L121.167 56.6179C121.22 56.5923 121.274 56.567 121.328 56.5428C122.18 56.1476 123.108 55.9414 124.047 55.9385C125.267 55.9407 126.459 56.299 127.478 56.9694C127.615 57.0603 127.71 57.2012 127.744 57.3618C127.778 57.5223 127.747 57.6897 127.658 57.8279L124.23 63.1991C124.149 63.3266 124.038 63.4316 123.906 63.5044C123.774 63.5771 123.626 63.6151 123.475 63.6148Z"
                                fill="#E6E6E6"
                            />
                            <path
                                d="M130.363 45.9005C131.447 45.9005 132.325 45.0219 132.325 43.9381C132.325 42.8542 131.447 41.9756 130.363 41.9756C129.279 41.9756 128.4 42.8542 128.4 43.9381C128.4 45.0219 129.279 45.9005 130.363 45.9005Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M123.635 41.7812C122.257 41.7812 120.935 42.3289 119.96 43.3036C118.985 44.2784 118.438 45.6004 118.438 46.979V49.178H121.142L122.436 46.979L122.824 49.178H131.032L128.833 46.979C128.833 45.6004 128.285 44.2784 127.311 43.3036C126.336 42.3289 125.014 41.7812 123.635 41.7812Z"
                                fill="#171717"
                            />
                            <path
                                d="M131.372 42.5934C131.589 41.9148 132.038 41.3344 132.641 40.9543C133.244 40.5742 133.961 40.4187 134.667 40.5152C135.917 40.7243 136.906 41.7296 137.495 42.8524C138.085 43.9752 138.357 45.2318 138.753 46.4364C139.149 47.6409 139.711 48.852 140.71 49.6318C141.71 50.4115 143.245 50.623 144.227 49.8209C144.115 50.6569 143.743 51.4364 143.163 52.0492C142.584 52.6621 141.826 53.0772 140.998 53.2359C140.169 53.3947 139.312 53.2889 138.547 52.9337C137.782 52.5785 137.148 51.9918 136.735 51.2565C136.217 50.3346 136.083 49.254 135.929 48.2077C135.775 47.1613 135.576 46.0786 134.957 45.2209C134.338 44.3631 133.18 43.8029 132.198 44.1936L131.372 42.5934Z"
                                fill="#171717"
                            />
                            <path
                                d="M67.5594 45.5877C65.7703 45.5875 64.0546 44.8766 62.7895 43.6115C61.5244 42.3464 60.8137 40.6305 60.8136 38.8414C60.8135 37.6212 60.8144 36.6883 60.8162 36.5556C60.8731 32.3761 61.9256 28.2704 63.8866 24.5791C60.6648 28.9897 58.8932 34.2926 58.8171 39.7542C58.8152 39.8869 58.8144 40.8198 58.8145 42.04C58.8146 43.8291 59.5253 45.5449 60.7904 46.8101C62.0554 48.0752 63.7712 48.7861 65.5603 48.7863C67.0305 48.7857 68.4603 48.3053 69.6325 47.418C70.8047 46.5307 71.6553 45.2851 72.055 43.8703C70.8198 44.978 69.2186 45.5897 67.5594 45.5877Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M85.713 27.81C87.7814 27.9088 89.7948 28.5081 91.5805 29.5564C93.3662 30.6047 94.8708 32.0708 95.9651 33.8287C97.0594 35.5866 97.7107 37.5839 97.8631 39.649C98.0155 41.714 97.6644 43.7852 96.84 45.6847C98.0324 44.2843 98.9089 42.6432 99.4096 40.8733C99.9103 39.1034 100.024 37.2463 99.7415 35.4287C99.4594 33.6111 98.7888 31.8757 97.7752 30.3408C96.7617 28.8058 95.4291 27.5075 93.8683 26.5343C92.3075 25.5611 90.5553 24.9358 88.7309 24.7012C86.9066 24.4666 85.0531 24.6281 83.2969 25.1747C81.5406 25.7213 79.9229 26.6402 78.5539 27.8687C77.185 29.0972 76.097 30.6065 75.3643 32.2936C76.6307 30.8037 78.2225 29.6246 80.0168 28.8472C81.8111 28.0699 83.7599 27.715 85.713 27.81Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M87.7876 87.5695C85.9625 87.5699 84.2104 86.8528 82.9092 85.5729C81.6081 84.293 80.8623 82.5529 80.8327 80.728C80.748 75.4391 80.7042 68.9227 80.7042 68.178C80.703 66.3663 80.9638 64.5639 81.4786 62.8268L81.4761 62.8262C81.7801 61.9543 82.1472 61.1057 82.5745 60.2871C81.2627 62.0352 80.2188 63.969 79.477 66.0248L79.4794 66.0254C78.9647 67.7625 78.7039 69.5649 78.7051 71.3766C78.7051 72.1213 78.7489 78.6377 78.8335 83.9266C78.8632 85.7515 79.609 87.4916 80.9101 88.7715C82.2112 90.0514 83.9634 90.7685 85.7885 90.7681C87.2933 90.7678 88.7575 90.2796 89.9615 89.3768C91.1654 88.474 92.0441 87.2051 92.4659 85.7606C91.1871 86.9266 89.5182 87.5719 87.7876 87.5695Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M25.2965 116.465L27.7472 116.465L28.9133 107.012L25.2959 107.012L25.2965 116.465Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M32.4746 118.741L24.7719 118.742L24.7717 115.765L29.4984 115.765C30.2877 115.765 31.0447 116.079 31.6028 116.637C32.161 117.195 32.4746 117.952 32.4746 118.741L32.4746 118.741Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M16.5006 116.465L18.9513 116.465L20.1174 107.012L16.5 107.012L16.5006 116.465Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M23.6787 118.741L15.976 118.742L15.9758 115.765L20.7025 115.765C21.4918 115.765 22.2488 116.079 22.8069 116.637C23.3651 117.195 23.6787 117.952 23.6787 118.741L23.6787 118.741Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M18.6425 113.558L16.2485 113.432C16.1251 113.426 16.0041 113.395 15.8927 113.341C15.7813 113.287 15.6817 113.212 15.5995 113.12C15.5174 113.028 15.4543 112.92 15.4141 112.803C15.3739 112.686 15.3573 112.562 15.3652 112.439L18.2265 80.7598L31.4029 84.3153L32.6724 83.969L28.7025 112.014C28.6686 112.225 28.5639 112.418 28.4055 112.561C28.2471 112.704 28.0445 112.79 27.8312 112.802L25.2506 112.922C25.1215 112.93 24.9924 112.91 24.8714 112.865C24.7503 112.819 24.64 112.749 24.5473 112.659C24.4547 112.569 24.3817 112.461 24.3331 112.341C24.2844 112.221 24.2611 112.093 24.2647 111.964L24.7323 95.1319C24.7345 95.054 24.7074 94.9782 24.6565 94.9193C24.6056 94.8604 24.5344 94.8228 24.4571 94.8137C24.3797 94.8047 24.3018 94.825 24.2387 94.8705C24.1755 94.9161 24.1317 94.9836 24.1159 95.0599L19.6065 112.815C19.564 113.025 19.4497 113.215 19.2831 113.35C19.1165 113.486 18.908 113.56 18.6931 113.559C18.6763 113.559 18.6595 113.559 18.6425 113.558Z"
                                fill="#171717"
                            />
                            <path
                                d="M25.7372 54.8396C28.4489 54.8396 30.6472 52.6413 30.6472 49.9296C30.6472 47.2178 28.4489 45.0195 25.7372 45.0195C23.0255 45.0195 20.8271 47.2178 20.8271 49.9296C20.8271 52.6413 23.0255 54.8396 25.7372 54.8396Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M17.5623 64.3554L18.1022 76.0038L18.2974 80.2416C18.3051 80.4261 18.3678 80.6041 18.4773 80.7528C18.5867 80.9015 18.7381 81.0141 18.9119 81.0763L31.5736 85.663C31.6759 85.701 31.7842 85.72 31.8934 85.7191C32.0181 85.7197 32.1416 85.6951 32.2566 85.6469C32.3717 85.5987 32.4758 85.5278 32.5628 85.4385C32.6498 85.3492 32.718 85.2432 32.7631 85.1269C32.8083 85.0107 32.8296 84.8865 32.8257 84.7619L32.3066 63.8177C32.2725 62.0993 31.64 60.4467 30.518 59.1447C29.3961 57.8427 27.855 56.9729 26.1606 56.6854C26.0381 56.6667 25.9135 56.648 25.7889 56.6314C24.7382 56.5009 23.6716 56.6023 22.6643 56.9284C21.657 57.2545 20.7334 57.7974 19.9584 58.5188C19.156 59.2568 18.5255 60.1621 18.1114 61.1707C17.6974 62.1792 17.5099 63.2664 17.5623 64.3554L17.5623 64.3554Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M37.6219 83.3383C37.3224 83.2453 37.0488 83.0837 36.8229 82.8662C36.597 82.6488 36.4251 82.3815 36.3208 82.0858C36.2165 81.7901 36.1828 81.4741 36.2224 81.163C36.2619 80.852 36.3736 80.5545 36.5486 80.2943L32.2549 74.5848L35.9601 74.3555L39.4694 79.8125C39.8451 80.1029 40.1066 80.5164 40.2079 80.9804C40.3092 81.4443 40.2439 81.9291 40.0235 82.3497C39.8031 82.7704 39.4416 83.1 39.0024 83.2807C38.5633 83.4615 38.0745 83.4819 37.6219 83.3383H37.6219Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M34.6033 79.2609C34.4896 79.2147 34.3861 79.1465 34.2989 79.06C34.2117 78.9736 34.1425 78.8708 34.0954 78.7574L27.6265 63.3453C27.4996 63.0436 27.4334 62.7198 27.4317 62.3924C27.4299 62.0651 27.4927 61.7406 27.6165 61.4375C27.7402 61.1344 27.9225 60.8587 28.1528 60.6261C28.3832 60.3935 28.6571 60.2085 28.959 60.0819C29.2608 59.9552 29.5847 59.8892 29.912 59.8877C30.2394 59.8862 30.5638 59.9493 30.8668 60.0733C31.1698 60.1973 31.4454 60.3797 31.6778 60.6102C31.9102 60.8408 32.0949 61.1149 32.2214 61.4168L38.6902 76.8291C38.7858 77.0576 38.7869 77.3147 38.6932 77.544C38.5995 77.7733 38.4186 77.9561 38.1903 78.0522L35.3185 79.2575C35.2055 79.3053 35.084 79.3303 34.9613 79.3309C34.8385 79.3315 34.7168 79.3077 34.6033 79.2609L34.6033 79.2609Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M24.1591 78.7182L30.3722 66.8216C30.492 66.5928 30.6977 66.4209 30.9441 66.3436C31.1905 66.2662 31.4576 66.2898 31.6866 66.4091L40.705 71.1191C40.9338 71.2389 41.1057 71.4446 41.183 71.691C41.2604 71.9374 41.2368 72.2044 41.1175 72.4335L34.9044 84.33C34.7845 84.5588 34.5789 84.7307 34.3325 84.8081C34.086 84.8854 33.819 84.8618 33.5899 84.7425L24.5716 80.0326C24.3428 79.9128 24.1709 79.7071 24.0936 79.4607C24.0162 79.2142 24.0398 78.9472 24.1591 78.7182Z"
                                fill="#3F3D56"
                            />
                            <path
                                d="M28.326 73.2821C28.2155 72.9887 28.038 72.7251 27.8076 72.5124C27.5772 72.2998 27.3002 72.1439 26.9989 72.0573C26.6975 71.9707 26.3801 71.9557 26.0719 72.0135C25.7637 72.0714 25.4734 72.2005 25.2239 72.3905L19.2709 68.4414L19.2607 72.1537L24.9154 75.3347C25.2276 75.6926 25.6558 75.9291 26.1249 76.0029C26.594 76.0766 27.0741 75.9828 27.481 75.7379C27.8879 75.4931 28.1956 75.1128 28.3501 74.6637C28.5046 74.2147 28.496 73.7255 28.326 73.2821Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M20.7989 74.1175L15.9337 70.2637C15.4074 70.087 14.9318 69.7852 14.5478 69.3842C14.1638 68.9832 13.8828 68.495 13.729 67.9615C13.5752 67.4281 13.5532 66.8652 13.6647 66.3214C13.7763 65.7775 14.0182 65.2688 14.3697 64.839L18.7872 59.0497C19.0942 58.6745 19.5259 58.4224 20.0034 58.3394C20.481 58.2564 20.9725 58.348 21.3881 58.5975C21.8036 58.847 22.1155 59.2377 22.2668 59.6983C22.418 60.1588 22.3984 60.6584 22.2116 61.1056L18.7164 66.8231L23.8529 69.2594C23.9724 69.3161 24.0784 69.3974 24.1641 69.4981C24.2498 69.5988 24.3131 69.7165 24.3499 69.8435C24.3867 69.9704 24.3962 70.1038 24.3776 70.2346C24.3591 70.3655 24.313 70.491 24.2424 70.6028L22.1689 73.8841C22.0988 73.9949 22.0063 74.0897 21.8972 74.1624C21.7882 74.2351 21.6651 74.2841 21.5359 74.3062C21.5307 74.3071 21.5256 74.3079 21.5204 74.3086C21.3935 74.3278 21.264 74.3207 21.1399 74.2879C21.0158 74.255 20.8997 74.197 20.7989 74.1175Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M22.0273 53.2176C22.0062 53.156 21.9995 53.0904 22.0077 53.0258C22.0159 52.9612 22.0388 52.8993 22.0747 52.8449C22.1105 52.7905 22.1583 52.745 22.2144 52.7119C22.2705 52.6789 22.3334 52.6591 22.3984 52.6541C22.5314 52.6613 22.6615 52.6954 22.7809 52.7544C22.9004 52.8133 23.0066 52.8958 23.0933 52.9969C23.271 53.2018 23.4778 53.3794 23.7072 53.5241C23.9448 53.6438 24.2669 53.6268 24.4023 53.3985C24.5295 53.1842 24.4423 52.8971 24.3654 52.6482C24.1695 52.0147 24.0599 51.3578 24.0395 50.695C24.0173 49.9553 24.1217 49.1833 24.5312 48.6063C25.0598 47.8617 26.0049 47.579 26.8993 47.5995C27.7937 47.62 28.6736 47.8961 29.5596 48.0706C29.8654 48.1309 30.2249 48.1617 30.4295 47.9246C30.647 47.6726 30.5671 47.2647 30.4746 46.9243C30.2345 46.0412 29.9798 45.1282 29.422 44.415C28.8189 43.6739 27.9573 43.1889 27.0109 43.0576C26.1023 42.945 25.1799 43.0497 24.3196 43.3631C22.918 43.8049 21.6847 44.664 20.7846 45.8257C19.8567 47.0611 19.4558 48.6137 19.6695 50.1439C19.8782 51.4766 20.5844 52.6807 21.6457 53.5133L22.0273 53.2176Z"
                                fill="#171717"
                            />
                            <path
                                d="M84.2149 116.504C82.9086 115.935 81.7523 115.071 80.8374 113.978C79.9225 112.886 79.2741 111.596 78.9431 110.21C78.6122 108.824 78.6079 107.38 78.9305 105.992C79.2532 104.605 79.894 103.311 80.8023 102.213C79.7492 102.982 78.8716 103.966 78.2279 105.1C77.5841 106.234 77.189 107.492 77.0686 108.79C76.9482 110.089 77.1053 111.398 77.5296 112.631C77.9538 113.864 78.6355 114.993 79.5293 115.942C80.4232 116.892 81.5087 117.64 82.7139 118.138C83.9191 118.636 85.2165 118.872 86.5198 118.83C87.8231 118.788 89.1027 118.47 90.2735 117.895C91.4443 117.321 92.4795 116.505 93.3106 115.5C92.0144 116.447 90.4925 117.039 88.8967 117.215C87.3008 117.391 85.6866 117.146 84.2149 116.504Z"
                                fill="#3F3D56"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_1461_12463">
                                <rect
                                    width="168.861"
                                    height="119"
                                    fill="white"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                }
                open={openConfirmStart}
                handelOk={() =>
                    changeAction('e058d6c5d28d483194ff1820227d922a')
                }
                handelClose={() => setOpenConfirmStart(false)}
            />
            <ModalConfirm
                title={t('Confirm to resolve')}
                text={t(
                    'You will not be able to edit this task again after confirmation'
                )}
                icon={
                    <svg
                        width="150"
                        height="108"
                        viewBox="0 0 150 108"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_1910_14959)">
                            <path
                                d="M117.893 9.71776C117.514 6.949 117.039 3.97632 115.079 1.97761C114.457 1.34342 113.713 0.841276 112.891 0.501456C112.068 0.161636 111.186 -0.00882479 110.296 0.00035175C109.406 0.00952829 108.527 0.198154 107.712 0.554852C106.898 0.911549 106.164 1.42893 105.555 2.07581C104.128 3.5923 103.498 5.72168 103.44 7.79947C103.383 9.87725 103.847 11.932 104.363 13.9462C107.089 14.0004 109.796 13.4697 112.299 12.3899C112.912 12.0916 113.549 11.8427 114.202 11.6456C114.863 11.4779 115.334 11.8999 115.949 12.194L116.287 11.55C116.563 12.0624 117.419 11.9105 117.73 11.4178C118.04 10.9251 117.972 10.2941 117.893 9.71776Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M106.503 21.4081L107.293 17.3898L101.373 14.8364L90.7887 9.78487C90.7149 9.31613 90.5001 8.88074 90.1725 8.53631C89.845 8.19187 89.4202 7.95462 88.9544 7.85593C88.4885 7.75725 88.0036 7.80178 87.5637 7.98363C87.1239 8.16549 86.7498 8.4761 86.4909 8.87438C86.2321 9.27266 86.1007 9.73984 86.1142 10.2141C86.1277 10.6884 86.2854 11.1474 86.5664 11.5305C86.8475 11.9135 87.2386 12.2025 87.6881 12.3593C88.1376 12.5161 88.6243 12.5332 89.0838 12.4084L99.1611 18.6042L106.503 21.4081Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M102.529 20.7282L106.817 16.3613L106.902 16.387C106.955 16.4031 112.283 18.0212 115.679 19.6654C116.063 19.8371 116.405 20.0901 116.68 20.4068C116.956 20.7236 117.159 21.0964 117.275 21.4993C117.444 22.0634 117.444 22.6645 117.275 23.2286C117.106 23.7928 116.775 24.2955 116.323 24.675C115.859 25.0891 115.285 25.3613 114.669 25.4589C114.053 25.5566 113.423 25.4755 112.852 25.2255L102.529 20.7282Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M102.516 39.9274L114.573 43.1372L117.008 31.7896L105.941 28.377L102.516 39.9274Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M115.922 36.8464L104.144 34.1479L101.888 28.7017C101.705 27.9244 101.749 27.1108 102.017 26.3579C102.284 25.6051 102.763 24.9446 103.397 24.4552L107.7 20.8356L110.007 17.8996L109.756 16.3437C109.711 16.0328 109.776 15.7159 109.941 15.448C110.106 15.18 110.359 14.9778 110.658 14.8763L113.732 13.7778C114.072 13.6512 114.448 13.6579 114.783 13.7968C115.118 13.9356 115.387 14.1961 115.537 14.5255L115.863 15.2767C115.863 15.2767 117.253 15.9285 118.037 16.2951C118.44 16.4778 118.8 16.7434 119.094 17.0743C119.387 17.4053 119.607 17.7942 119.739 18.2156C120.938 22.0784 120.615 26.2515 118.834 29.8851L115.922 36.8464Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M11.1734 94.659L5.4784 93.1408C4.64104 90.1712 4.54395 87.0428 5.19558 84.0273C7.68013 88.9203 14.3529 89.8429 18.3058 93.6585C19.5296 94.858 20.4667 96.3164 21.0478 97.9258C21.6288 99.5351 21.8389 101.254 21.6625 102.955L23.0267 106.893C20.2576 106.784 17.5451 106.078 15.0761 104.824C12.6072 103.57 10.4405 101.797 8.72534 99.6287C7.77523 98.4026 6.98387 97.0622 6.36996 95.6391C8.75297 95.2913 11.1734 94.659 11.1734 94.659Z"
                                fill="#F2F2F2"
                            />
                            <path
                                d="M81.9255 108.001H26.1072C24.6113 107.999 23.1771 107.406 22.1193 106.352C21.0615 105.299 20.4665 103.87 20.4648 102.379V28.7462C20.4665 27.2559 21.0615 25.8271 22.1193 24.7733C23.1771 23.7195 24.6113 23.1267 26.1072 23.125H81.9255C83.4214 23.1267 84.8556 23.7195 85.9133 24.7733C86.9711 25.8271 87.5661 27.2559 87.5678 28.7462V102.379C87.5661 103.87 86.9711 105.299 85.9133 106.352C84.8556 107.406 83.4214 107.999 81.9255 108.001Z"
                                fill="#E6E6E6"
                            />
                            <path
                                d="M60.6225 103.442H30.032C28.6699 103.44 27.3641 102.9 26.401 101.941C25.4378 100.981 24.8961 99.6803 24.8945 98.3233V32.7999C24.8961 31.4429 25.4378 30.142 26.401 29.1824C27.3641 28.2229 28.67 27.6832 30.032 27.6816H78.0031C79.3652 27.6832 80.671 28.2229 81.6342 29.1824C82.5973 30.142 83.1391 31.4429 83.1406 32.7999V81.0079C83.1339 86.9557 80.7592 92.6579 76.5377 96.8636C72.3162 101.069 66.5926 103.435 60.6225 103.442Z"
                                fill="white"
                            />
                            <path
                                d="M73.2166 40.261H34.8164C34.652 40.2612 34.4891 40.2291 34.337 40.1666C34.185 40.1041 34.0468 40.0123 33.9304 39.8966C33.814 39.7809 33.7216 39.6435 33.6584 39.4922C33.5953 39.3409 33.5627 39.1787 33.5625 39.0149C33.5623 38.851 33.5945 38.6887 33.6572 38.5373C33.72 38.3858 33.8121 38.2482 33.9282 38.1322C34.0443 38.0162 34.1823 37.9241 34.3342 37.8612C34.486 37.7983 34.6488 37.7658 34.8133 37.7656H73.2166C73.5487 37.7652 73.8674 37.8963 74.1026 38.13C74.3378 38.3636 74.4701 38.6808 74.4705 39.0117C74.4709 39.3426 74.3394 39.6601 74.1048 39.8944C73.8703 40.1287 73.5519 40.2605 73.2197 40.261H73.2166Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M73.2171 45.1908H34.8169C34.4847 45.1908 34.1662 45.0593 33.9313 44.8253C33.6964 44.5913 33.5645 44.274 33.5645 43.943C33.5645 43.6121 33.6964 43.2948 33.9313 43.0608C34.1662 42.8268 34.4847 42.6953 34.8169 42.6953H73.2171C73.5492 42.6953 73.8678 42.8268 74.1026 43.0608C74.3375 43.2948 74.4695 43.6121 74.4695 43.943C74.4695 44.274 74.3375 44.5913 74.1026 44.8253C73.8678 45.0593 73.5492 45.1908 73.2171 45.1908Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M51.4624 50.1224H34.8169C34.4847 50.1224 34.1662 49.991 33.9313 49.757C33.6964 49.523 33.5645 49.2056 33.5645 48.8747C33.5645 48.5438 33.6964 48.2264 33.9313 47.9924C34.1662 47.7584 34.4847 47.627 34.8169 47.627H51.4624C51.7946 47.627 52.1132 47.7584 52.348 47.9924C52.5829 48.2264 52.7149 48.5438 52.7149 48.8747C52.7149 49.2056 52.5829 49.523 52.348 49.757C52.1132 49.991 51.7946 50.1224 51.4624 50.1224Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M73.2166 60.4485H34.8164C34.4843 60.4489 34.1656 60.3178 33.9304 60.0841C33.6953 59.8504 33.5629 59.5333 33.5625 59.2024C33.5621 58.8715 33.6936 58.5539 33.9282 58.3197C34.1628 58.0854 34.4811 57.9535 34.8133 57.9531H73.2166C73.5487 57.9527 73.8674 58.0838 74.1026 58.3175C74.3378 58.5511 74.4701 58.8683 74.4705 59.1992C74.4709 59.5301 74.3394 59.8477 74.1048 60.0819C73.8703 60.3162 73.5519 60.448 73.2197 60.4485H73.2166Z"
                                fill="#E4E4E4"
                            />
                            <path
                                d="M73.2171 65.3783H34.8169C34.4847 65.3783 34.1662 65.2468 33.9313 65.0128C33.6964 64.7788 33.5645 64.4615 33.5645 64.1305C33.5645 63.7996 33.6964 63.4823 33.9313 63.2483C34.1662 63.0143 34.4847 62.8828 34.8169 62.8828H73.2171C73.5492 62.8828 73.8678 63.0143 74.1026 63.2483C74.3375 63.4823 74.4695 63.7996 74.4695 64.1305C74.4695 64.4615 74.3375 64.7788 74.1026 65.0128C73.8678 65.2468 73.5492 65.3783 73.2171 65.3783Z"
                                fill="#E4E4E4"
                            />
                            <path
                                d="M51.4624 70.308H34.8169C34.4847 70.308 34.1662 70.1765 33.9313 69.9425C33.6964 69.7085 33.5645 69.3912 33.5645 69.0602C33.5645 68.7293 33.6964 68.4119 33.9313 68.178C34.1662 67.944 34.4847 67.8125 34.8169 67.8125H51.4624C51.7946 67.8125 52.1132 67.944 52.348 68.178C52.5829 68.4119 52.7149 68.7293 52.7149 69.0602C52.7149 69.3912 52.5829 69.7085 52.348 69.9425C52.1132 70.1765 51.7946 70.308 51.4624 70.308Z"
                                fill="#E4E4E4"
                            />
                            <path
                                d="M73.2166 80.634H34.8164C34.4843 80.6344 34.1656 80.5034 33.9304 80.2697C33.6953 80.036 33.5629 79.7188 33.5625 79.3879C33.5621 79.057 33.6936 78.7395 33.9282 78.5052C34.1628 78.2709 34.4811 78.1391 34.8133 78.1387H73.2166C73.5487 78.1383 73.8674 78.2693 74.1026 78.503C74.3378 78.7367 74.4701 79.0539 74.4705 79.3848C74.4709 79.7157 74.3394 80.0332 74.1048 80.2675C73.8703 80.5017 73.5519 80.6336 73.2197 80.634H73.2166Z"
                                fill="#E4E4E4"
                            />
                            <path
                                d="M73.2171 85.5638H34.8169C34.4847 85.5638 34.1662 85.4324 33.9313 85.1984C33.6964 84.9644 33.5645 84.647 33.5645 84.3161C33.5645 83.9852 33.6964 83.6678 33.9313 83.4338C34.1662 83.1998 34.4847 83.0684 34.8169 83.0684H73.2171C73.5492 83.0684 73.8678 83.1998 74.1026 83.4338C74.3375 83.6678 74.4695 83.9852 74.4695 84.3161C74.4695 84.647 74.3375 84.9644 74.1026 85.1984C73.8678 85.4324 73.5492 85.5638 73.2171 85.5638Z"
                                fill="#E4E4E4"
                            />
                            <path
                                d="M51.462 90.4935H34.8164C34.4847 90.4929 34.1667 90.3611 33.9324 90.1272C33.698 89.8933 33.5664 89.5763 33.5664 89.2458C33.5664 88.9153 33.698 88.5983 33.9324 88.3643C34.1667 88.1304 34.4847 87.9987 34.8164 87.998H51.462C51.7937 87.9987 52.1117 88.1304 52.346 88.3643C52.5804 88.5983 52.712 88.9153 52.712 89.2458C52.712 89.5763 52.5804 89.8933 52.346 90.1272C52.1117 90.3611 51.7937 90.4929 51.462 90.4935Z"
                                fill="#E4E4E4"
                            />
                            <path
                                d="M81 43C91.4934 43 100 34.4934 100 24C100 13.5066 91.4934 5 81 5C70.5066 5 62 13.5066 62 24C62 34.4934 70.5066 43 81 43Z"
                                fill="#3ACC6C"
                            />
                            <path
                                opacity="0.16"
                                d="M81 40.3756C76.1931 40.375 71.5651 38.5817 68.0489 35.3573C64.5328 32.1329 62.3898 27.7171 62.0521 23C62.0213 23.4351 62 23.8729 62 24.3157C62.0019 29.2717 64.0045 34.0241 67.5675 37.5279C71.1305 41.0317 75.9621 43 81 43C86.0379 43 90.8695 41.0317 94.4325 37.5279C97.9955 34.0241 99.9981 29.2717 100 24.3157C100 23.8729 99.9787 23.4351 99.9479 23C99.6102 27.7171 97.4672 32.1329 93.9511 35.3573C90.4349 38.5817 85.8069 40.375 81 40.3756Z"
                                fill="#231F20"
                            />
                            <path
                                d="M109.286 28.021L105.822 25.8184L101.27 30.3727L92.6777 38.3365C92.2129 38.2334 91.7275 38.2733 91.2859 38.4509C90.8443 38.6285 90.4672 38.9355 90.2045 39.3313C89.9419 39.727 89.806 40.1929 89.8149 40.6673C89.8237 41.1417 89.977 41.6022 90.2543 41.988C90.5316 42.3737 90.9199 42.6665 91.3679 42.8275C91.8159 42.9886 92.3024 43.0104 92.763 42.8901C93.2237 42.7697 93.6368 42.5128 93.9478 42.1534C94.2587 41.7941 94.4528 41.3491 94.5044 40.8774L103.98 33.8019L109.286 28.021Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M107.197 31.4566L104.688 25.8831L104.742 25.8138C104.777 25.7704 108.238 21.4231 111.017 18.8761C111.318 18.583 111.679 18.3589 112.076 18.2193C112.473 18.0796 112.895 18.0279 113.314 18.0677C113.903 18.1176 114.464 18.3377 114.929 18.7009C115.394 19.064 115.743 19.5545 115.932 20.1122C116.149 20.6943 116.193 21.3263 116.059 21.9327C115.925 22.5391 115.619 23.0943 115.176 23.5317L107.197 31.4566Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M109.464 13.1378C112.472 13.1378 114.911 10.7084 114.911 7.71148C114.911 4.7146 112.472 2.28516 109.464 2.28516C106.456 2.28516 104.018 4.7146 104.018 7.71148C104.018 10.7084 106.456 13.1378 109.464 13.1378Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M101.003 104.113H98.7514L97.6797 95.4609H101.003V104.113Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M102.191 108H100.577L100.288 106.481L99.5502 108H95.2675C95.0622 108 94.8623 107.935 94.6969 107.814C94.5316 107.693 94.4094 107.522 94.3483 107.327C94.2872 107.131 94.2904 106.922 94.3573 106.728C94.4243 106.535 94.5515 106.368 94.7204 106.252L98.1405 103.899V102.363L101.738 102.577L102.191 108Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M129.224 102.207L127.132 103.037L122.924 95.3926L126.012 94.168L129.224 102.207Z"
                                fill="#FFB8B8"
                            />
                            <path
                                d="M131.771 105.381L130.271 105.976L129.439 104.671L129.317 106.354L125.338 107.932C125.148 108.008 124.938 108.021 124.739 107.969C124.54 107.918 124.364 107.804 124.234 107.645C124.105 107.486 124.03 107.29 124.021 107.086C124.011 106.882 124.067 106.68 124.181 106.51L126.485 103.063L125.915 101.636L129.337 100.51L131.771 105.381Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M101.87 100.139H97.2129L98.5001 78.3391L97.5591 63.5625L97.5611 63.5507L101.071 42.369C101.347 40.6987 102.093 39.1408 103.222 37.8761L103.265 37.8281L115.01 40.7181L116.191 43.4007C120.223 45.79 121.497 59.2635 121.549 59.8374L123.256 76.6336L127.432 97.2189L124.492 98.7964L124.442 98.6988L115.158 80.3067L109.295 60.9111L105.541 78.3676L101.87 100.139Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M116.211 7.966C116.018 6.7047 115.816 5.43283 115.364 4.24519C114.911 3.05755 114.181 1.94514 113.134 1.27236C111.476 0.207171 109.33 0.412608 107.472 1.02533C106.034 1.49919 104.631 2.2194 103.618 3.37727C102.604 4.53515 102.035 6.18731 102.412 7.70127C104.394 7.23463 106.377 6.76799 108.359 6.30134L108.142 6.45412C108.793 6.77749 109.362 7.24436 109.805 7.81928C110.247 8.3942 110.553 9.06207 110.698 9.77219C110.84 10.4909 110.819 11.2321 110.638 11.942C110.457 12.652 110.12 13.313 109.651 13.8772C111.003 13.3994 112.355 12.9215 113.707 12.4437C114.542 12.1488 115.435 11.8089 115.93 11.0524C116.504 10.1753 116.371 9.01273 116.211 7.966Z"
                                fill="#2F2E41"
                            />
                            <path
                                d="M0.285547 107.948H149.714C149.79 107.948 149.863 107.918 149.916 107.865C149.97 107.811 150 107.739 150 107.663C150 107.588 149.97 107.516 149.916 107.462C149.863 107.409 149.79 107.379 149.714 107.379H0.285547C0.209814 107.379 0.137187 107.409 0.0836354 107.462C0.0300841 107.516 0 107.588 0 107.663C0 107.739 0.0300841 107.811 0.0836354 107.865C0.137187 107.918 0.209814 107.948 0.285547 107.948Z"
                                fill="#CCCCCC"
                            />
                            <path
                                d="M78.6871 31C78.6449 31 78.6021 30.999 78.5594 30.9971C78.1844 30.9795 77.8178 30.884 77.4847 30.717C77.1516 30.5501 76.8599 30.3156 76.6295 30.0298L73.5481 26.2098C73.1244 25.6835 72.9345 25.0166 73.0201 24.3554C73.1058 23.6942 73.4599 23.0928 74.0049 22.6832L74.1152 22.6003C74.6612 22.1917 75.3529 22.0086 76.0387 22.0911C76.7245 22.1735 77.3484 22.5149 77.7735 23.0403C77.9118 23.2119 78.087 23.3527 78.287 23.4529C78.487 23.5532 78.7071 23.6105 78.9322 23.621C79.1576 23.6337 79.3831 23.5983 79.5927 23.5172C79.8022 23.4362 79.9906 23.3115 80.1444 23.1521L86.4009 16.7835C86.8767 16.3004 87.5318 16.0189 88.2224 16.0009C88.9131 15.9829 89.583 16.2297 90.0852 16.6873L90.1869 16.78C90.6882 17.2387 90.9803 17.8705 90.999 18.5366C91.0178 19.2028 90.7618 19.8489 90.2871 20.3332L80.5783 30.2152C80.335 30.4632 80.0418 30.6607 79.7166 30.7957C79.3914 30.9306 79.0411 31.0001 78.6871 31Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_1910_14959">
                                <rect width="150" height="108" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                }
                open={openConfirmComplete}
                handelOk={() => completeForm()}
                handelClose={() => setOpenConfirmComplete(false)}
            />
            <ModalReject
                title={t('Confirm Rejection')}
                text={t(
                    'You will not be able to edit this task again after confirmation'
                )}
                icon={
                    <svg
                        width="220"
                        height="120"
                        viewBox="0 0 220 120"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M145.757 81.3195C145.757 91.8173 139.516 95.4828 131.818 95.4828C124.12 95.4828 117.879 91.8173 117.879 81.3195C117.879 70.8217 131.818 57.4668 131.818 57.4668C131.818 57.4668 145.757 70.8217 145.757 81.3195Z"
                            fill="#65707A"
                        />
                        <path
                            d="M131.454 85.0912L137.395 74.2219L131.476 83.713L131.54 79.7626L135.635 71.8988L131.557 78.7171L131.673 71.6121L136.057 65.3517L131.691 70.4949L131.763 57.4668L131.329 73.9749L126.889 67.1785L131.275 75.368L130.86 83.3029L130.848 83.0923L125.708 75.9115L130.832 83.8364L130.78 84.8288L130.771 84.8438L130.775 84.9252L129.721 95.5141H131.129L131.298 94.6587L136.409 86.7532L131.311 93.8769L131.454 85.0912Z"
                            fill="#3F3D56"
                        />
                        <path
                            d="M193.493 47.5646C193.493 67.618 181.572 74.6199 166.866 74.6199C152.16 74.6199 140.239 67.618 140.239 47.5646C140.239 27.5111 166.866 2 166.866 2C166.866 2 193.493 27.5111 193.493 47.5646Z"
                            fill="#F2F2F2"
                        />
                        <path
                            d="M165.896 71.5524L166.169 54.7695L177.518 34.0066L166.212 52.1367L166.335 44.5903L174.156 29.5687L166.367 42.5934L166.588 29.0211L174.963 17.062L166.622 26.8869L166.76 2L165.894 34.9458L165.965 33.5866L157.45 20.5519L165.829 36.1956L165.035 51.3535L165.012 50.9512L155.195 37.2341L164.982 52.3725L164.883 54.2682L164.865 54.2968L164.873 54.4523L162.86 92.9093H165.55L165.872 73.0456L175.636 57.9443L165.896 71.5524Z"
                            fill="#3F3D56"
                        />
                        <path
                            d="M192.401 89.5518C192.401 95.5372 153.573 118 108.184 118C62.7952 118 26 106.375 26 100.389C26 94.4039 61.892 101.518 107.281 101.518C152.67 101.518 192.401 83.5664 192.401 89.5518Z"
                            fill="#3F3D56"
                        />
                        <path
                            opacity="0.1"
                            d="M192.401 89.5518C192.401 95.5372 153.573 118 108.184 118C62.7952 118 26 106.375 26 100.389C26 94.4039 61.892 101.518 107.281 101.518C152.67 101.518 192.401 83.5664 192.401 89.5518Z"
                            fill="black"
                        />
                        <path
                            d="M192.401 89.5516C192.401 95.537 153.573 111.227 108.184 111.227C62.7952 111.227 26 106.374 26 100.389C26 94.4037 61.892 94.7446 107.281 94.7446C152.67 94.7446 192.401 83.5662 192.401 89.5516Z"
                            fill="#3F3D56"
                        />
                        <path
                            opacity="0.1"
                            d="M109.104 104.225C128.379 104.225 144.004 103.016 144.004 101.526C144.004 100.035 128.379 98.8262 109.104 98.8262C89.8295 98.8262 74.2043 100.035 74.2043 101.526C74.2043 103.016 89.8295 104.225 109.104 104.225Z"
                            fill="black"
                        />
                        <path
                            d="M81.4562 47.4336C81.4562 47.4336 91.6734 47.6228 89.7813 49.4203C87.8892 51.2177 80.7939 49.4203 80.7939 49.4203L81.4562 47.4336Z"
                            fill="#A0616A"
                        />
                        <path
                            d="M60.1685 25.6006C60.1685 25.6006 64.2937 24.8639 65.728 28.194C67.1623 31.5242 70.1081 41.0216 70.1081 41.0216C70.1081 41.0216 77.9913 46.2397 79.4251 46.0683C80.859 45.8968 83.3101 46.2466 82.8605 47.8109C82.4109 49.3752 82.6105 51.149 81.5754 51.3664C80.5403 51.5838 78.894 49.5086 77.634 50.5081C76.3741 51.5077 65.1454 47.8568 64.4246 47.1004C63.7037 46.3439 57.7129 29.9639 57.7129 29.9639C57.7129 29.9639 57.9525 25.5472 60.1685 25.6006Z"
                            fill="#7B67FB"
                        />
                        <path
                            d="M69.0157 95.918L69.4887 99.8913L65.5154 100.932L63.2449 99.8913V96.391L69.0157 95.918Z"
                            fill="#A0616A"
                        />
                        <path
                            d="M58.3258 98.4727L58.7988 102.446L54.8255 103.487L52.5549 102.446V98.9456L58.3258 98.4727Z"
                            fill="#A0616A"
                        />
                        <path
                            d="M69.394 52.4938L71.1914 59.0214L73.8403 72.2659C73.8403 72.2659 74.5972 75.4824 73.0835 79.3612C71.5698 83.2399 68.8263 95.9168 69.394 96.6737C69.9616 97.4305 62.9609 97.9981 63.0555 97.2413C63.1501 96.4844 64.0962 86.078 64.0962 86.078C64.0962 86.078 65.4206 76.9015 66.0828 75.7662C66.7451 74.631 63.0555 71.7929 63.0555 71.7929C63.0555 71.7929 62.1095 82.6723 60.6904 83.6184C59.2714 84.5644 59.4606 99.2279 58.7984 99.4172C58.1361 99.6064 53.3113 100.363 52.7437 99.4172C52.1761 98.4711 52.7437 82.6723 52.7437 82.6723C52.7437 82.6723 55.9603 70.6577 55.298 68.9548C54.6358 67.2519 55.0142 59.9674 55.0142 59.9674C55.0142 59.9674 52.5545 54.3858 53.879 51.4531L69.394 52.4938Z"
                            fill="#2F2E41"
                        />
                        <path
                            d="M69.1103 16.1673C69.1103 16.1673 65.1369 21.0867 65.3261 23.2626C65.5153 25.4385 59.0823 19.2892 59.0823 19.2892C59.0823 19.2892 63.7179 13.0454 63.7179 11.7209C63.7179 10.3965 69.1103 16.1673 69.1103 16.1673Z"
                            fill="#A0616A"
                        />
                        <path
                            d="M69.0634 18.0111C72.5118 18.0111 75.3073 15.2157 75.3073 11.7673C75.3073 8.3189 72.5118 5.52344 69.0634 5.52344C65.615 5.52344 62.8196 8.3189 62.8196 11.7673C62.8196 15.2157 65.615 18.0111 69.0634 18.0111Z"
                            fill="#A0616A"
                        />
                        <path
                            d="M53.3276 48.956C53.0447 50.0099 52.6937 51.2048 52.7439 52.2113C52.7761 52.8632 54.5063 53.2908 56.8989 53.5708C59.1173 53.831 61.9053 53.9634 64.4397 54.0315C67.1009 54.1034 69.4802 54.1034 70.624 54.1034C74.0297 54.1034 71.2862 51.9275 69.9617 50.8869C68.6373 49.8463 68.9211 35.0881 69.0157 33.196C69.1103 31.3039 68.1643 25.8169 68.1643 24.7763C68.1643 23.7357 65.9382 21.0196 65.9382 21.0196C65.9382 21.0196 65.4208 22.5058 63.3395 20.5191C61.2582 18.5325 58.5147 17.9648 58.5147 17.9648C56.4334 18.7217 52.9331 27.0468 52.7439 28.4658C52.6672 29.042 52.7306 31.9927 52.8593 35.3615C53.0457 40.2856 53.3711 46.1066 53.5953 46.7243C53.7722 47.2115 53.5764 48.0289 53.3276 48.956Z"
                            fill="#7B67FB"
                        />
                        <path
                            d="M63.4344 54.4805L64.0966 56.8456L61.5423 59.4945L60.6909 55.8049L63.4344 54.4805Z"
                            fill="#A0616A"
                        />
                        <path
                            d="M64.2855 98.8494C64.2855 98.8494 66.2721 101.12 67.7858 99.6062C69.2994 98.0925 69.2048 97.1465 69.4887 97.1465C69.7725 97.1465 74.0296 100.931 74.0296 100.931C74.0296 100.931 81.3141 102.633 77.3408 103.863C73.3674 105.093 62.1096 104.242 62.1096 103.863C62.1096 103.485 61.8258 98.4709 62.8664 98.4709L64.2855 98.8494Z"
                            fill="#2F2E41"
                        />
                        <path
                            d="M53.5958 101.404C53.5958 101.404 55.5824 103.675 57.0961 102.161C58.6097 100.647 58.5151 99.7012 58.799 99.7012C59.0828 99.7012 63.3399 103.485 63.3399 103.485C63.3399 103.485 70.6244 105.188 66.6511 106.418C62.6777 107.648 51.4199 106.796 51.4199 106.418C51.4199 106.04 51.1361 101.026 52.1767 101.026L53.5958 101.404Z"
                            fill="#2F2E41"
                        />
                        <path
                            d="M62.0528 16.7524C61.8511 16.8827 61.5885 17.0148 61.3866 16.8849C60.6357 15.0122 60.0744 13.069 59.7112 11.0844C59.5837 10.3873 59.4952 9.6123 59.8825 9.0188C60.0352 8.78473 60.2551 8.59331 60.367 8.33718C60.5364 7.94929 60.4249 7.5003 60.4812 7.08078C60.5991 6.20188 61.4299 5.58888 62.2654 5.29158C63.1008 4.99428 64.0082 4.90205 64.8046 4.51194C65.5607 4.14151 66.1663 3.52718 66.8675 3.061C67.5687 2.59481 68.4668 2.27606 69.2477 2.59108C69.9385 2.86976 70.3688 3.57387 71.0217 3.93238C71.4648 4.17567 71.979 4.24337 72.4735 4.3478C73.8481 4.63945 75.1387 5.23904 76.2481 6.10146C76.5181 6.29402 76.7508 6.53395 76.9351 6.80962C77.7729 8.1891 76.2728 10.0646 76.9346 11.5366L75.5038 10.4076C75.1217 10.0733 74.6907 9.79945 74.2259 9.59541C73.7519 9.41588 73.1906 9.3942 72.7601 9.66162C72.1559 10.0369 71.992 10.821 71.7809 11.5002C71.5699 12.1794 71.1032 12.9326 70.3921 12.9152C69.4251 12.8916 69.0869 11.542 68.2191 11.1148C67.6534 10.8363 66.9413 11.0197 66.4591 11.4259C65.9768 11.8321 65.6874 12.4215 65.4752 13.0152C65.3425 13.3862 65.2181 13.8045 64.9825 14.1261C64.7227 14.4808 64.3904 14.5094 64.1129 14.7743C63.3905 15.4638 62.9464 16.1751 62.0528 16.7524Z"
                            fill="#2F2E41"
                        />
                        <path
                            opacity="0.1"
                            d="M53.3279 48.9558C54.5038 50.6615 55.8292 52.4211 56.8992 53.5705C59.1176 53.8307 61.9056 53.9631 64.4401 54.0312C63.9873 53.4174 63.4211 52.8958 62.7722 52.4949C61.5424 51.738 58.6096 42.7507 58.6096 42.7507C58.6096 42.7507 62.2046 33.4796 63.1506 29.9792C64.0966 26.4789 60.4071 24.4922 60.4071 24.4922C58.7042 23.0732 55.7715 26.3843 55.7715 26.3843C55.7715 26.3843 54.2749 30.8988 52.8596 35.3612C53.046 40.2853 53.3714 46.1063 53.5956 46.7241C53.7725 47.2113 53.5767 48.0286 53.3279 48.9558Z"
                            fill="black"
                        />
                        <path
                            d="M60.1229 23.7344C60.1229 23.7344 63.8125 25.7211 62.8664 29.2214C61.9204 32.7217 58.3255 41.9929 58.3255 41.9929C58.3255 41.9929 61.2582 50.9802 62.488 51.7371C63.7179 52.4939 65.4207 54.2914 64.0963 55.2374C62.7718 56.1834 61.8258 57.6971 60.8798 57.2241C59.9337 56.7511 59.9337 54.1022 58.3255 54.1022C56.7172 54.1022 50.1896 44.2634 50.095 43.2227C50.0004 42.1821 55.4874 25.6265 55.4874 25.6265C55.4874 25.6265 58.4201 22.3153 60.1229 23.7344Z"
                            fill="#7B67FB"
                        />
                        <path
                            d="M136.843 49.5924L135.778 48.5281C135.158 47.9073 134.316 47.5586 133.438 47.5586C132.56 47.5586 131.718 47.9073 131.097 48.5281L110.454 69.1716L89.8103 48.5281C89.1895 47.9073 88.3476 47.5586 87.4696 47.5586C86.5917 47.5586 85.7498 47.9073 85.129 48.5281L84.0647 49.5924C83.7574 49.8998 83.5135 50.2647 83.3472 50.6663C83.1808 51.0679 83.0952 51.4983 83.0952 51.933C83.0952 52.3677 83.1808 52.7982 83.3472 53.1998C83.5135 53.6014 83.7574 53.9663 84.0647 54.2737L104.708 74.9171L84.0647 95.5606C83.7574 95.868 83.5135 96.2329 83.3472 96.6345C83.1808 97.0361 83.0952 97.4665 83.0952 97.9012C83.0952 98.3359 83.1808 98.7664 83.3472 99.168C83.5135 99.5696 83.7574 99.9345 84.0647 100.242L85.129 101.306C85.7498 101.927 86.5917 102.276 87.4696 102.276C88.3476 102.276 89.1895 101.927 89.8103 101.306L110.454 80.6627L131.097 101.306C131.718 101.927 132.56 102.276 133.438 102.276C134.316 102.276 135.158 101.927 135.778 101.306L136.843 100.242C137.464 99.6211 137.812 98.7791 137.812 97.9012C137.812 97.0233 137.464 96.1814 136.843 95.5606L116.199 74.9171L136.843 54.2737C137.464 53.6529 137.812 52.8109 137.812 51.933C137.812 51.0551 137.464 50.2132 136.843 49.5924Z"
                            fill="#FF6584"
                        />
                        <path
                            opacity="0.1"
                            d="M83.3276 96.6842L103.358 76.6537L103.165 76.4609L84.0643 95.5619C83.7444 95.8815 83.4936 96.2635 83.3276 96.6842Z"
                            fill="black"
                        />
                        <path
                            opacity="0.1"
                            d="M83.7789 50.2635C84.3997 49.6427 85.2416 49.2939 86.1195 49.2939C86.9974 49.2939 87.8394 49.6427 88.4602 50.2635L109.104 70.9069L129.747 50.2635C130.368 49.6427 131.21 49.2939 132.088 49.2939C132.966 49.2939 133.808 49.6427 134.428 50.2635L135.493 51.3277C135.949 51.7844 136.262 52.3647 136.393 52.9971C136.524 53.6294 136.467 54.2863 136.229 54.8867L136.842 54.2737C137.15 53.9663 137.394 53.6014 137.56 53.1998C137.726 52.7982 137.812 52.3677 137.812 51.933C137.812 51.4983 137.726 51.0679 137.56 50.6663C137.394 50.2647 137.15 49.8998 136.842 49.5924L135.778 48.5281C135.157 47.9073 134.315 47.5586 133.437 47.5586C132.56 47.5586 131.718 47.9073 131.097 48.5281L110.453 69.1716L89.8099 48.5281C89.1891 47.9073 88.3472 47.5586 87.4693 47.5586C86.5913 47.5586 85.7494 47.9073 85.1286 48.5281L84.0643 49.5924C83.7444 49.912 83.4936 50.2941 83.3276 50.7147L83.7789 50.2635Z"
                            fill="black"
                        />
                        <path
                            opacity="0.1"
                            d="M116.392 75.1094L114.849 76.6519L135.493 97.2954C135.949 97.7521 136.262 98.3323 136.393 98.9647C136.524 99.5971 136.467 100.254 136.229 100.854L136.842 100.241C137.15 99.9339 137.394 99.569 137.56 99.1674C137.726 98.7658 137.812 98.3353 137.812 97.9007C137.812 97.466 137.726 97.0355 137.56 96.6339C137.394 96.2323 137.15 95.8674 136.842 95.56L116.392 75.1094Z"
                            fill="black"
                        />
                        <path
                            d="M50.0371 88.875C50.0371 97.5938 44.8539 100.638 38.4601 100.638C32.0663 100.638 26.8831 97.5938 26.8831 88.875C26.8831 80.1562 38.4601 69.0645 38.4601 69.0645C38.4601 69.0645 50.0371 80.1562 50.0371 88.875Z"
                            fill="#65707A"
                        />
                        <path
                            d="M38.1572 92.0076L43.0917 82.9802L38.1758 90.8629L38.2292 87.5819L41.6299 81.0507L38.2433 86.7136L38.3391 80.8127L41.9807 75.613L38.3542 79.8848L38.414 69.0645L38.0538 82.7751L34.3662 77.1305L38.0091 83.932L37.6642 90.5224L37.654 90.3475L33.3857 84.3835L37.641 90.9654L37.5979 91.7897L37.5901 91.8021L37.5937 91.8697L36.7184 100.664H37.8879L38.0282 99.9537L42.2731 93.3879L38.0388 99.3044L38.1572 92.0076Z"
                            fill="#3F3D56"
                        />
                    </svg>
                }
                open={openConfirmEnd}
                handelClose={() => cancelReject()}
                form={reasonForm}
                id={id}
                setOpenConfirmEnd={setOpenConfirmEnd}
                setTriggerDetails={setTriggerDetails}
                triggerDetails={triggerDetails}
            />
        </div>
    );
};
export default DataBreachLogForm;
